import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/images/echec.svg'
import _imports_1 from '../../../assets/images/success.svg'
import _imports_2 from '../../../assets/images/pending.svg'
import _imports_3 from '../../../assets/images/i-money1.jpg'
import _imports_4 from '../../../assets/images/arrowtopleft.svg'
import _imports_5 from '../../../assets/images/arrowtopright.svg'
import _imports_6 from '../../../assets/images/check.svg'
import _imports_7 from '../../../assets/images/imoji.svg'
import _imports_8 from '../../../assets/images/arrowbottomleft.svg'
import _imports_9 from '../../../assets/images/arrowbottomright.svg'


const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing",
  id: "back"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 flex-wrap gap-10" }
const _hoisted_4 = { class: "d-sm-flex flex-wrap align-items-center w-100 w-lg-30" }
const _hoisted_5 = {
  key: 1,
  type: "button",
  class: "default-btn d-block text-center w-80 border-0 box-shadow fw-medium text-white rounded-1 pt-12 pb-12 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
  "data-bs-toggle": "modal",
  "data-bs-target": "#generateLink"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "d-sm-flex align-items-center" }
const _hoisted_9 = { class: "select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0" }
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = {
  id: "",
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_19 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "form-check mb-0" }
const _hoisted_23 = { class: "badge text-outline-primary" }
const _hoisted_24 = {
  key: 0,
  class: "flaticon-web",
  style: {"font-weight":"bold"}
}
const _hoisted_25 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_32 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_33 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_34 = {
  key: 2,
  class: "badge text-outline-info"
}
const _hoisted_35 = {
  key: 3,
  class: "badge text-outline-info"
}
const _hoisted_36 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { id: "transactionsTable" }
const _hoisted_39 = {
  id: "headerLeftText",
  class: "d-lg-inline-block p-2 text-start"
}
const _hoisted_40 = {
  id: "headerRightText",
  class: "d-inline-block p-2 text-end redcolor"
}
const _hoisted_41 = {
  id: "headerRightText",
  class: "d-inline-block p-2 text-end redcolor",
  style: {"margin-top":"-2%","font-weight":"1000"}
}
const _hoisted_42 = {
  id: "headerLeftText",
  class: "d-lg-inline-block p-2 text-start",
  style: {"margin-top":"-2%"}
}
const _hoisted_43 = { style: {"margin-top":"7%"} }
const _hoisted_44 = {
  class: "shadow-none lh-1 fw-medium",
  id: "title",
  style: {}
}
const _hoisted_45 = { id: "title1" }
const _hoisted_46 = {
  class: "text-end",
  id: "title2"
}
const _hoisted_47 = { class: "date" }
const _hoisted_48 = { class: "date" }
const _hoisted_49 = {
  style: {"padding-left":"1%","padding-right":"1%"},
  class: ""
}
const _hoisted_50 = {
  id: "tableLayout",
  class: "table",
  style: {"margin-right":"1%"}
}
const _hoisted_51 = {
  id: "t-thead-pdf",
  style: {"border-top-left-radius":"5px","border-bottom-left-radius":"5px"}
}
const _hoisted_52 = {
  style: {},
  class: "tableHeader"
}
const _hoisted_53 = { class: "tableHeader" }
const _hoisted_54 = { class: "tableHeader" }
const _hoisted_55 = { class: "tableHeader" }
const _hoisted_56 = {
  scope: "col",
  class: "tableHeader"
}
const _hoisted_57 = {
  scope: "col",
  class: "tableHeader"
}
const _hoisted_58 = {
  scope: "col",
  class: "tableHeader1",
  style: {"border-top-left-radius":"5px","border-bottom-left-radius":"5px"}
}
const _hoisted_59 = { class: "fw-medium" }
const _hoisted_60 = { class: "d-flex align-items-center" }
const _hoisted_61 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_62 = { class: "fw-medium" }
const _hoisted_63 = { class: "fw-medium" }
const _hoisted_64 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_65 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_66 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_67 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { key: 2 }
const _hoisted_71 = { key: 3 }
const _hoisted_72 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_73 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_74 = { class: "fw-bold" }
const _hoisted_75 = { class: "fw-bold" }
const _hoisted_76 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_77 = { class: "fw-bold" }
const _hoisted_78 = { class: "fw-bold" }
const _hoisted_79 = {
  key: 2,
  class: "mt-15 mt-md-0"
}
const _hoisted_80 = { class: "pagination mb-0" }
const _hoisted_81 = {
  key: 0,
  class: "page-item"
}
const _hoisted_82 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_83 = ["onClick"]
const _hoisted_84 = {
  key: 1,
  class: "page-item"
}
const _hoisted_85 = {
  key: 3,
  class: "mt-15 mt-md-0"
}
const _hoisted_86 = { class: "pagination mb-0" }
const _hoisted_87 = {
  key: 0,
  class: "page-item"
}
const _hoisted_88 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_89 = ["onClick"]
const _hoisted_90 = {
  key: 1,
  class: "page-item"
}
const _hoisted_91 = {
  key: 4,
  class: "mt-15 mt-md-0"
}
const _hoisted_92 = { class: "pagination mb-0" }
const _hoisted_93 = {
  key: 0,
  class: "page-item"
}
const _hoisted_94 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_95 = ["onClick"]
const _hoisted_96 = {
  key: 1,
  class: "page-item"
}
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_100 = { class: "modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down" }
const _hoisted_101 = { class: "modal-content" }
const _hoisted_102 = { class: "modal-header" }
const _hoisted_103 = {
  key: 0,
  class: "modal-title fs-5"
}
const _hoisted_104 = {
  key: 1,
  class: "modal-title fs-5"
}
const _hoisted_105 = { class: "modal-tabs" }
const _hoisted_106 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_107 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_108 = { class: "modal-body" }
const _hoisted_109 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_110 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_111 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_112 = { class: "row g-3" }
const _hoisted_113 = {
  key: 0,
  class: "col-12 col-md-3"
}
const _hoisted_114 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_115 = { value: "" }
const _hoisted_116 = ["value"]
const _hoisted_117 = {
  key: 1,
  class: "col-12 col-md-3"
}
const _hoisted_118 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_119 = { value: "" }
const _hoisted_120 = { value: "SN" }
const _hoisted_121 = { value: "CI" }
const _hoisted_122 = { class: "col-12 col-md-3" }
const _hoisted_123 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_124 = { value: "" }
const _hoisted_125 = ["value"]
const _hoisted_126 = { class: "col-12 col-md-3" }
const _hoisted_127 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_128 = { value: "" }
const _hoisted_129 = { value: "SUCCEEDED" }
const _hoisted_130 = { value: "PROCESSING" }
const _hoisted_131 = { value: "PENDING" }
const _hoisted_132 = { value: "FAILED" }
const _hoisted_133 = { class: "row g-3 mt-1" }
const _hoisted_134 = { class: "col-12 col-md-3" }
const _hoisted_135 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_136 = { class: "col-12 col-md-3" }
const _hoisted_137 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_138 = { class: "col-12 col-md-3" }
const _hoisted_139 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_140 = { value: "" }
const _hoisted_141 = ["value"]
const _hoisted_142 = {
  class: "col-12 col-md-3",
  id: "container_sub_business"
}
const _hoisted_143 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_144 = { value: "" }
const _hoisted_145 = ["value"]
const _hoisted_146 = { class: "row g-3 mt-1" }
const _hoisted_147 = { class: "col-12 col-md-3" }
const _hoisted_148 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_149 = { key: 1 }
const _hoisted_150 = { class: "row g-3" }
const _hoisted_151 = { class: "col-12 col-md-3" }
const _hoisted_152 = { class: "col-12 col-md-3" }
const _hoisted_153 = { class: "col-12 col-md-3" }
const _hoisted_154 = { class: "col-12 col-md-3" }
const _hoisted_155 = { class: "row g-3 mt-1" }
const _hoisted_156 = { class: "col-12 col-md-3" }
const _hoisted_157 = { class: "col-12 col-md-3" }
const _hoisted_158 = { class: "col-12 col-md-3" }
const _hoisted_159 = { class: "col-12 col-md-3" }
const _hoisted_160 = { class: "row g-3 mt-1" }
const _hoisted_161 = { class: "col-12 col-md-3" }
const _hoisted_162 = { class: "col-12 col-md-3" }
const _hoisted_163 = { class: "col-12 col-md-3" }
const _hoisted_164 = { class: "col-12 col-md-3" }
const _hoisted_165 = { class: "row g-3 mt-1" }
const _hoisted_166 = { class: "col-12 col-md-3" }
const _hoisted_167 = { class: "col-12 col-md-3" }
const _hoisted_168 = { class: "col-12 col-md-3" }
const _hoisted_169 = { class: "col-12 col-md-3" }
const _hoisted_170 = { value: "" }
const _hoisted_171 = { value: "1" }
const _hoisted_172 = { value: "2" }
const _hoisted_173 = { class: "row g-3 mt-1" }
const _hoisted_174 = { class: "col-12 col-md-3" }
const _hoisted_175 = { class: "col-12 col-md-3" }
const _hoisted_176 = { value: "" }
const _hoisted_177 = { class: "col-12 col-md-3" }
const _hoisted_178 = { value: "" }
const _hoisted_179 = { class: "col-12 col-md-3" }
const _hoisted_180 = { value: "" }
const _hoisted_181 = { class: "modal-footer" }
const _hoisted_182 = ["disabled"]
const _hoisted_183 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_184 = { style: {"color":"#FFF"} }
const _hoisted_185 = ["disabled"]
const _hoisted_186 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_187 = { style: {"color":"#FFF"} }
const _hoisted_188 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_189 = { class: "modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down" }
const _hoisted_190 = { class: "modal-content" }
const _hoisted_191 = { class: "modal-header" }
const _hoisted_192 = { class: "modal-title fs-5" }
const _hoisted_193 = { class: "modal-tabs" }
const _hoisted_194 = { class: "modal-body" }
const _hoisted_195 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_196 = { class: "row g-3" }
const _hoisted_197 = {
  key: 0,
  class: "col-12 col-md-3"
}
const _hoisted_198 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_199 = {
  key: 1,
  class: "col-12 col-md-3"
}
const _hoisted_200 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_201 = {
  key: 2,
  class: "col-12 col-md-3"
}
const _hoisted_202 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_203 = {
  key: 3,
  class: "col-12 col-md-3"
}
const _hoisted_204 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_205 = {
  key: 4,
  class: "col-12 col-md-3"
}
const _hoisted_206 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_207 = {
  key: 5,
  class: "col-12 col-md-3"
}
const _hoisted_208 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_209 = { key: 0 }
const _hoisted_210 = { class: "row g-3" }
const _hoisted_211 = {
  key: 0,
  class: "col-12 col-md-3"
}
const _hoisted_212 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_213 = {
  key: 1,
  class: "col-12 col-md-3"
}
const _hoisted_214 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_215 = {
  key: 2,
  class: "col-12 col-md-3"
}
const _hoisted_216 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_217 = ["value"]
const _hoisted_218 = {
  key: 3,
  class: "col-12 col-md-3"
}
const _hoisted_219 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_220 = ["value"]
const _hoisted_221 = {
  key: 4,
  class: "col-12 col-md-3"
}
const _hoisted_222 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_223 = ["value"]
const _hoisted_224 = {
  key: 5,
  class: "col-12 col-md-3"
}
const _hoisted_225 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_226 = ["value"]
const _hoisted_227 = {
  key: 6,
  class: "col-12 col-md-3"
}
const _hoisted_228 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_229 = {
  key: 7,
  class: "col-12 col-md-3"
}
const _hoisted_230 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_231 = {
  key: 8,
  class: "col-12 col-md-3"
}
const _hoisted_232 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_233 = ["value"]
const _hoisted_234 = {
  key: 9,
  class: "col-12 col-md-3"
}
const _hoisted_235 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_236 = ["value"]
const _hoisted_237 = {
  key: 10,
  class: "col-12 col-md-3"
}
const _hoisted_238 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_239 = ["value"]
const _hoisted_240 = {
  key: 11,
  class: "col-12 col-md-3"
}
const _hoisted_241 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_242 = ["value"]
const _hoisted_243 = {
  key: 12,
  class: "col-12 col-md-3"
}
const _hoisted_244 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_245 = ["value"]
const _hoisted_246 = {
  key: 13,
  class: "col-12 col-md-3"
}
const _hoisted_247 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_248 = {
  key: 14,
  class: "col-12 col-md-3"
}
const _hoisted_249 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_250 = {
  key: 15,
  class: "col-12 col-md-3"
}
const _hoisted_251 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_252 = ["value"]
const _hoisted_253 = {
  key: 16,
  class: "col-12 col-md-3"
}
const _hoisted_254 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_255 = ["value"]
const _hoisted_256 = {
  key: 17,
  class: "col-12 col-md-3"
}
const _hoisted_257 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_258 = ["value"]
const _hoisted_259 = {
  key: 18,
  class: "col-12 col-md-3"
}
const _hoisted_260 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_261 = ["value"]
const _hoisted_262 = {
  key: 19,
  class: "col-12 col-md-3"
}
const _hoisted_263 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_264 = {
  key: 20,
  class: "col-12 col-md-3"
}
const _hoisted_265 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_266 = {
  key: 21,
  class: "col-12"
}
const _hoisted_267 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_268 = ["value"]
const _hoisted_269 = {
  class: "modal fade",
  id: "changeStatusModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_270 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_271 = { class: "modal-content edit-status-modal-content" }
const _hoisted_272 = { class: "modal-body pt-10" }
const _hoisted_273 = { class: "edit-status-code-box mb-20" }
const _hoisted_274 = { class: "edit-status-code-value" }
const _hoisted_275 = { class: "form-group mb-15" }
const _hoisted_276 = { class: "form-group mb-15" }
const _hoisted_277 = { class: "form-group mb-15" }
const _hoisted_278 = { class: "form-group mb-5" }
const _hoisted_279 = {
  key: 0,
  class: "text-danger fs-13"
}
const _hoisted_280 = {
  key: 0,
  class: "text-danger fs-13 mt-10 mb-0"
}
const _hoisted_281 = { class: "modal-footer border-0 pt-0" }
const _hoisted_282 = ["disabled"]
const _hoisted_283 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_284 = {
  class: "modal fade",
  id: "transactionStatusModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_285 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_286 = { class: "modal-content status-modal-content" }
const _hoisted_287 = { class: "modal-body text-center p-0" }
const _hoisted_288 = {
  key: 0,
  class: "status-loading"
}
const _hoisted_289 = {
  key: 1,
  class: "status-card"
}
const _hoisted_290 = { key: 0 }
const _hoisted_291 = { key: 1 }
const _hoisted_292 = { key: 2 }
const _hoisted_293 = { class: "status-title mt-15 mb-5" }
const _hoisted_294 = { class: "status-checkout-id mb-20" }
const _hoisted_295 = { class: "status-amount" }
const _hoisted_296 = { class: "status-badges mt-20" }
const _hoisted_297 = { class: "status-item" }
const _hoisted_298 = { class: "status-item" }
const _hoisted_299 = {
  class: "modal fade",
  id: "generateLink",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_300 = { class: "modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down" }
const _hoisted_301 = { class: "modal-content" }
const _hoisted_302 = { class: "modal-header" }
const _hoisted_303 = { class: "modal-title fs-5" }
const _hoisted_304 = { class: "modal-body" }
const _hoisted_305 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_306 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_307 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_308 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_309 = { class: "row g-3" }
const _hoisted_310 = {
  key: 0,
  class: "col-md-5"
}
const _hoisted_311 = { class: "col-6 col-md-3" }
const _hoisted_312 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_313 = {
  key: 1,
  class: "col-9 col-md-7"
}
const _hoisted_314 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_315 = {
  key: 2,
  class: "col-3 col-md-2",
  style: {"padding-top":"2%"}
}
const _hoisted_316 = {
  class: "d-block text-black fw-semibold mb-10",
  style: {"visibility":"hidden"}
}
const _hoisted_317 = { class: "d-flex align-items-center gap-3" }
const _hoisted_318 = ["title"]
const _hoisted_319 = { class: "modal-footer" }
const _hoisted_320 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}
const _hoisted_321 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_322 = {
  class: "modal fade",
  id: "qrCodeModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_323 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_324 = { class: "modal-content" }
const _hoisted_325 = { class: "modal-header" }
const _hoisted_326 = { class: "modal-title fs-5" }
const _hoisted_327 = { class: "modal-body text-center" }
const _hoisted_328 = ["src"]
const _hoisted_329 = { class: "text-muted fs-14 mb-0" }
const _hoisted_330 = { class: "modal-footer justify-content-center" }
const _hoisted_331 = {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_332 = ["disabled"]
const _hoisted_333 = {
  class: "modal fade",
  id: "receiptModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_334 = { class: "modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down" }
const _hoisted_335 = { class: "modal-content" }
const _hoisted_336 = { id: "receipt" }
const _hoisted_337 = { id: "header_receipt" }
const _hoisted_338 = { style: {"padding":"2% 5% 2% 5%","color":"#fff"} }
const _hoisted_339 = { id: "header_text" }
const _hoisted_340 = { id: "body_receipt" }
const _hoisted_341 = { id: "body_first_section" }
const _hoisted_342 = { class: "section_label" }
const _hoisted_343 = { class: "section_content" }
const _hoisted_344 = { class: "section_label" }
const _hoisted_345 = { class: "section_content" }
const _hoisted_346 = { class: "section_label" }
const _hoisted_347 = { class: "section_content" }
const _hoisted_348 = { style: {"margin-top":"10%"} }
const _hoisted_349 = { class: "section_label" }
const _hoisted_350 = { class: "section_content_other" }
const _hoisted_351 = { id: "body_second_section" }
const _hoisted_352 = { class: "section_label" }
const _hoisted_353 = { class: "section_content_other1" }
const _hoisted_354 = { key: 0 }
const _hoisted_355 = { class: "section_label" }
const _hoisted_356 = { class: "section_content_other1" }
const _hoisted_357 = { key: 1 }
const _hoisted_358 = { class: "section_label" }
const _hoisted_359 = { class: "section_content_other1" }
const _hoisted_360 = { key: 2 }
const _hoisted_361 = { class: "section_label" }
const _hoisted_362 = { class: "section_content_other1" }
const _hoisted_363 = { key: 3 }
const _hoisted_364 = { class: "section_label" }
const _hoisted_365 = { class: "section_content_other1" }
const _hoisted_366 = { id: "body_third_section" }
const _hoisted_367 = { class: "section_label" }
const _hoisted_368 = { class: "modal-footer" }
const _hoisted_369 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_370 = { id: "header_receipt" }
const _hoisted_371 = { style: {"padding":"2% 5% 2% 5%","color":"#fff"} }
const _hoisted_372 = { id: "header_text" }
const _hoisted_373 = { id: "body_receipt" }
const _hoisted_374 = { id: "body_first_section" }
const _hoisted_375 = { key: 0 }
const _hoisted_376 = { class: "section_label" }
const _hoisted_377 = { class: "section_content" }
const _hoisted_378 = { class: "section_label" }
const _hoisted_379 = { class: "section_content" }
const _hoisted_380 = { class: "section_label" }
const _hoisted_381 = { class: "section_content" }
const _hoisted_382 = { class: "section_label" }
const _hoisted_383 = { class: "section_content" }
const _hoisted_384 = { style: {"margin-top":"10%"} }
const _hoisted_385 = { class: "section_label" }
const _hoisted_386 = { class: "section_content_other" }
const _hoisted_387 = { id: "body_second_section" }
const _hoisted_388 = { class: "section_label" }
const _hoisted_389 = { class: "section_content_other1" }
const _hoisted_390 = { key: 0 }
const _hoisted_391 = { class: "section_label" }
const _hoisted_392 = { class: "section_content_other1" }
const _hoisted_393 = { key: 1 }
const _hoisted_394 = { class: "section_label" }
const _hoisted_395 = { class: "section_content_other1" }
const _hoisted_396 = { key: 2 }
const _hoisted_397 = { class: "section_label" }
const _hoisted_398 = { class: "section_content_other1" }
const _hoisted_399 = { key: 3 }
const _hoisted_400 = { class: "section_label" }
const _hoisted_401 = { class: "section_content_other1" }
const _hoisted_402 = { id: "body_third_section" }
const _hoisted_403 = { class: "section_label" }

import { ref, onMounted, onBeforeUnmount, inject, nextTick, computed } from "vue";
import axios from 'axios';
import flatpickr from "flatpickr";
import html2pdf from "html2pdf.js";
import { useI18n } from "vue-i18n";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf'
import { Modal } from 'bootstrap';
import QRCode from 'qrcode';

import LeadscontentPdf from "./LeadsContentPdf.vue";
import router from '../../../router/index'
import conf from '../../../../env.json'
import {current_permissions} from '../../../utils/permission';
import { showToast,validate_phone_number,checkSessionValidate } from "@/utils/function";
import {Business,Transaction} from "@/utils/Model";
import stateStore from "../../../utils/store";
declare interface Organization {
  id : string,
  code: string,
  name: string,
  description: string,
  email: string,
  createdAt: string
  }

  declare interface Operator {
  id : string,
  code: string,
  mnoName: string,
  status: string,
  countryCode: string
  }

const leadPlaceholder = "Select date";


export default /*@__PURE__*/_defineComponent({
  __name: 'LeadsContent',
  setup(__props) {


const stateStoreInstance = stateStore;
stateStoreInstance.setRole('collecte')
const PDFReceipt = ref<HTMLElement | null>(null);
const backApi=inject('back');
let environment=process.env.VUE_APP_TEST
const { t } = useI18n();
  let data = [];
let beginDate = ref('');
let endDate = ref('');
let today = ref('');
let phone_number = ref('');
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedStatus = ref('');
const selectedBusiness = ref('');
const loader = ref(false);
const page = ref(1);
const total = ref(0);
let link = ref('');
let qrCodeDataUrl = ref('');
let amount = ref(0);
const pagesLeft = ref(0);
const currentPage = ref(0);
const numPages = ref(0);
const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const operator = ref('');
const paymentStatus = ref('');
const screenSelected = ref('');
const btnLoad = ref(true);
const btnLoad1 = ref(true);
const errors = ref('');
const errorId = ref('');
let result = ref(0);
const transactions =ref(new Array<Transaction>());
const transaction1s =ref(new Array<Transaction>());
const organizations =ref(new Array<Organization>());
const operators =ref(new Array<Operator>());
let operatorsTemp =new Array<Operator>();
const transaction =ref({} as Transaction);
const business =ref(new Array<Business>());
const subBusiness =ref(new Array<Business>());
let businessTemp =new Array<Business>();
let role: string|null = localStorage.getItem('role');

const isPrivilegedRole = ['SUPERADMIN', 'BUSINESS', 'SUPPORT'].includes(role || '');

const isSuperAdmin = role === 'SUPERADMIN';

const changeStatusCheckoutId = ref('');
const newStatusValue = ref('');
const newPaymentStatusValue = ref('');
const btnLoadStatus = ref(true);
const changeStatusError = ref('');

const newDescriptionValue = ref('');
const newStateValue = ref('');
const stateError = ref('');

const statusDetails = ref<any>({});
const statusLoading = ref(false);
let statusModalListenerAttached = false;

const filterCode = ref('');
const filterCheckoutId = ref('');
const filterPayoutId = ref('');
const filterClientReference = ref('');
const filterClientId = ref('');
const filterDescription = ref('');
const filterPublicToken = ref('');
const filterState = ref('');
const filterAmount = ref('');
const filterMaxAmount = ref('');
const filterMinAmount = ref('');
const filterIntBulkId = ref('');
const filterIntOperatorBulkId = ref('');
const filterBulkId = ref('');
const filterOperationType = ref('');
const filterTransactionDate = ref('');
const filterUser = ref('');
const filterPayoutType = ref('');
const filterValidationStatus = ref('');
const filterPublicTokenValidationStatus = ref('');

// ═══ Onglets actifs ═══
const activeFilterTab = ref<'base' | 'advanced'>('base');
const activeDetailTab = ref<'main' | 'advanced'>('main');

const isFilled = (v: any) => v !== '' && v !== null && v !== undefined;

const activeBaseFiltersCount = computed(() => {
  return [
    selectedOrganization.value,
    selectedOperator.value,
    selectedStatus.value,
    selectedBusiness.value,
    phone_number.value,
  ].filter(isFilled).length;
});

const activeAdvancedFiltersCount = computed(() => {
  return [
    filterCode.value, filterCheckoutId.value, filterPayoutId.value,
    filterClientReference.value, filterClientId.value, filterDescription.value,
    filterPublicToken.value, filterState.value, filterAmount.value,
    filterMinAmount.value, filterMaxAmount.value, filterIntBulkId.value,
    filterIntOperatorBulkId.value, filterBulkId.value, filterOperationType.value,
    filterTransactionDate.value, filterUser.value, filterPayoutType.value,
    filterValidationStatus.value, filterPublicTokenValidationStatus.value,
  ].filter(isFilled).length;
});

const onStateInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let val = input.value;

  val = val.replace(/[^0-9]/g, '');

  if (val.length > 1) {
    val = val.slice(0, 1);
  }

  if (val !== '' && parseInt(val, 10) > 5) {
    val = '5';
  }

  newStateValue.value = val;
  input.value = val;

  if (val === '') {
    stateError.value = '';
  } else if (parseInt(val, 10) > 5) {
    stateError.value = 'La valeur ne peut pas dépasser 5.';
  } else {
    stateError.value = '';
  }
};

let url = '';
if (role == 'SUPERADMIN' || role == 'BUSINESS' || role == 'SUPPORT') {
  url = backApi + '/secure/transactions/extended';
} else {
  url = backApi + '/secure/transactions';
}

  function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();
        day = day<10?'0'+day:day;
        return day+'/'+month+'/'+year;

    }
}

function formatDateTimeFr(value: string | null | undefined){
    if(!value) return '';
    const d = new Date(value);
    if (isNaN(d.getTime())) return '';
    const day = String(d.getDate()).padStart(2,'0');
    const month = String(d.getMonth()+1).padStart(2,'0');
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2,'0');
    const minutes = String(d.getMinutes()).padStart(2,'0');
    const seconds = String(d.getSeconds()).padStart(2,'0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

function hasValue(value: any): boolean {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '' || trimmed === '—' || trimmed === 'null' || trimmed === 'undefined') return false;
  }
  if (typeof value === 'number' && isNaN(value)) return false;
  return true;
}

function formatDateEn(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;
        day = day<10?'0'+day:day;
        return year+'-'+month+'-'+day;

    }
}

function formatDateEnBis(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;
        day = day<10?'0'+day:day;
        return year+'-'+month+'-'+day;

    }
}

function handleOrganizationChange(event) {
      selectedOrganization.value = event.target.value;
    }

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleStatusChange(event) {
  selectedStatus.value = event.target.value;
}

function handleCountryChange(event) {
  var j = 0;
  var operatorArr = new Array<Operator>();
  while(j<operatorsTemp.length){
      if(operatorsTemp[j].countryCode == event.target.value){
          operatorArr.push(operatorsTemp[j]);
      }
      j++;
  }
   operators.value = operatorArr;
}

function handleFilterOperationTypeChange(event) {
  filterOperationType.value = event.target.value;
}

function handleFilterPayoutTypeChange(event) {
  filterPayoutType.value = event.target.value;
}

function handleFilterValidationStatusChange(event) {
  filterValidationStatus.value = event.target.value;
}

function handleFilterPublicTokenValidationStatusChange(event) {
  filterPublicTokenValidationStatus.value = event.target.value;
}

function buildFilterQuery(): string {
  const params = new URLSearchParams();

  if (filterCode.value) params.append('code', filterCode.value);
  if (filterCheckoutId.value) params.append('checkoutId', filterCheckoutId.value);
  if (filterPayoutId.value) params.append('payoutId', filterPayoutId.value);
  if (filterClientReference.value) params.append('clientReference', filterClientReference.value);
  if (filterClientId.value) params.append('clientId', filterClientId.value);
  if (filterDescription.value) params.append('description', filterDescription.value);
  if (filterPublicToken.value) params.append('publicToken', filterPublicToken.value);
  if (filterState.value) params.append('state', filterState.value);
  if (filterAmount.value !== '' && filterAmount.value !== null) params.append('amount', String(filterAmount.value));
  if (filterMaxAmount.value !== '' && filterMaxAmount.value !== null) params.append('maxAmount', String(filterMaxAmount.value));
  if (filterMinAmount.value !== '' && filterMinAmount.value !== null) params.append('minAmount', String(filterMinAmount.value));
  if (filterIntBulkId.value) params.append('intBulkId', filterIntBulkId.value);
  if (filterIntOperatorBulkId.value) params.append('intOperatorBulkId', filterIntOperatorBulkId.value);
  if (filterBulkId.value) params.append('bulkId', filterBulkId.value);
  if (filterTransactionDate.value) params.append('transactionDate', filterTransactionDate.value);
  if (filterUser.value) params.append('user', filterUser.value);
  if (filterPayoutType.value) params.append('payoutType', filterPayoutType.value);
  if (filterValidationStatus.value) params.append('validationStatus', filterValidationStatus.value);
  if (filterPublicTokenValidationStatus.value) params.append('publicTokenValidationStatus', filterPublicTokenValidationStatus.value);

  return params.toString();
}

function resolveOperationType(): string {
  return filterOperationType.value ? filterOperationType.value : process.env.VUE_APP_PAYIN_OPTTYPE;
}

function resetAdvancedFilters() {
  filterCode.value = '';
  filterCheckoutId.value = '';
  filterPayoutId.value = '';
  filterClientReference.value = '';
  filterClientId.value = '';
  filterDescription.value = '';
  filterPublicToken.value = '';
  filterState.value = '';
  filterAmount.value = '';
  filterMaxAmount.value = '';
  filterMinAmount.value = '';
  filterIntBulkId.value = '';
  filterIntOperatorBulkId.value = '';
  filterBulkId.value = '';
  filterOperationType.value = '';
  filterTransactionDate.value = '';
  filterUser.value = '';
  filterPayoutType.value = '';
  filterValidationStatus.value = '';
  filterPublicTokenValidationStatus.value = '';

  const opType = document.getElementById('filterOperationType') as HTMLSelectElement | null;
  if (opType) opType.value = '';
  const payoutType = document.getElementById('filterPayoutType') as HTMLSelectElement | null;
  if (payoutType) payoutType.value = '';
  const validationStatusEl = document.getElementById('filterValidationStatus') as HTMLSelectElement | null;
  if (validationStatusEl) validationStatusEl.value = '';
  const publicTokenValidationStatusEl = document.getElementById('filterPublicTokenValidationStatus') as HTMLSelectElement | null;
  if (publicTokenValidationStatusEl) publicTokenValidationStatusEl.value = '';
}

function reset(){
  amount.value = 0;
  link.value = '';
  result.value=0;
  qrCodeDataUrl.value = '';
  const qrModalEl = document.getElementById('qrCodeModal');
  if (qrModalEl) {
    Modal.getInstance(qrModalEl)?.hide();
  }
}

function copyToCliboard() {
  const copyText = document.getElementById("link") as HTMLInputElement | null;
  if (!copyText) return;
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(copyText.value);
  showToast("Copié","green");
}

async function showQrCodeModal() {
  if (!link.value) {
    showToast("Générez d'abord un lien de paiement", "red");
    return;
  }

  try {
    qrCodeDataUrl.value = await QRCode.toDataURL(link.value, {
      width: 250,
      margin: 2,
    });

    const qrModalEl = document.getElementById('qrCodeModal');
    if (qrModalEl) {
      Modal.getOrCreateInstance(qrModalEl).show();
    }
  } catch {
    showToast("Erreur lors de la génération du QR code", "red");
  }
}

function downloadQrCode() {
  if (!qrCodeDataUrl.value) return;

  const anchor = document.createElement('a');
  anchor.href = qrCodeDataUrl.value;
  anchor.download = 'qrcode-paiement.png';
  anchor.click();
}

const generateLink = ()=>{

try {
  axios.post(`${backApi}/secure/transactions/token`,{
          amount:amount.value==0?null:amount.value,
          operationType:process.env.VUE_APP_PAYIN_OPTTYPE,
        }, {
      headers: {
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }
      }).then((response) => {
        if(response.status === 201){
          link.value =  response.data.ticketUrl
          result.value=1;
        }

    }).catch((error) => {
          if( error.response){
              if(error.response.status === 401){
                router.push('/')

              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              }

          }
  });
} catch (error) {
         errors.value="une erreur inattendue est apparue"

}

}

const openMenuId = ref<string | null>(null);
const menuPosition = ref({ top: 0, left: 0 });
let menuOpenedAt = 0;

function toggleActionMenu(event: MouseEvent, checkoutId: string) {
  if (openMenuId.value === checkoutId) {
    closeActionMenu();
    return;
  }

  const button = event.currentTarget as HTMLElement;
  const rect = button.getBoundingClientRect();
  const menuWidth = 220;

  let left = rect.right - menuWidth;
  if (left < 8) left = 8;
  if (left + menuWidth > window.innerWidth - 8) {
    left = window.innerWidth - menuWidth - 8;
  }

  menuPosition.value = { top: rect.bottom + 4, left };
  openMenuId.value = checkoutId;
  menuOpenedAt = Date.now();

  nextTick(() => {
    const menuEl = document.querySelector('.action-menu-fixed') as HTMLElement | null;
    if (!menuEl) return;
    const menuHeight = menuEl.offsetHeight;

    let top = rect.bottom + 4;
    if (top + menuHeight > window.innerHeight - 8) {
      top = rect.top - menuHeight - 4;
    }
    if (top < 8) top = 8;

    menuPosition.value = { ...menuPosition.value, top };
  });
}

function closeActionMenu() {
  openMenuId.value = null;
}

function findTransactionInList(checkoutId: string) {
  return transactions.value.find((t) => t.checkoutId === checkoutId)
      || transaction1s.value.find((t) => t.checkoutId === checkoutId);
}

function setTransactionData(data) {
  transaction.value = data;
  operator.value = data.operator?.mnoName ?? '';
  amount.value = data.amount != null ? data.amount.toLocaleString() : 0;

  if (data.paymentStatus === 'SUCCEEDED') {
    paymentStatus.value = "SUCCESS";
  } else if (data.paymentStatus === 'PROCESSING') {
    paymentStatus.value = "EN COURS";
  } else if (data.paymentStatus === 'PENDING') {
    paymentStatus.value = "EN ATTENTE";
  } else {
    paymentStatus.value = "ECHEC";
  }

  loader.value = true;
}

function handleView(checkoutId: string) {
  const found = findTransactionInList(checkoutId);
  if (found) {
    setTransactionData(found);
  } else {
    loadTransaction(checkoutId);
  }
  closeActionMenu();

  // Réinitialiser sur l'onglet principal
  activeDetailTab.value = 'main';

  const modalEl = document.getElementById('companyModal');
  if (modalEl) Modal.getOrCreateInstance(modalEl).show();
}

function handleReceipt(checkoutId: string) {
  const found = findTransactionInList(checkoutId);
  if (found) {
    setTransactionData(found);
  } else {
    loadTransaction(checkoutId);
  }
  closeActionMenu();
  const modalEl = document.getElementById('receiptModal');
  if (modalEl) Modal.getOrCreateInstance(modalEl).show();
}

function handleChangeStatus(checkoutId: string) {
  const found = findTransactionInList(checkoutId);

  changeStatusCheckoutId.value = found?.code ?? checkoutId;

  newStatusValue.value = found?.status ?? '';
  newPaymentStatusValue.value = found?.paymentStatus ?? '';

  newDescriptionValue.value = (found as any)?.description ?? '';
  newStateValue.value = (found as any)?.state != null ? String((found as any).state) : '';
  stateError.value = '';

  changeStatusError.value = '';
  closeActionMenu();

  const modalEl = document.getElementById('changeStatusModal');
  if (modalEl) {
    Modal.getOrCreateInstance(modalEl).show();
  }
}

function submitChangeStatus() {
  changeStatusError.value = '';

  if (!changeStatusCheckoutId.value) {
    changeStatusError.value = "Le code de la transaction est requis.";
    return;
  }

  const payload: any = { code: changeStatusCheckoutId.value };
  if (newStatusValue.value) payload.status = newStatusValue.value;
  if (newPaymentStatusValue.value) payload.paymentStatus = newPaymentStatusValue.value;

  if (newDescriptionValue.value && newDescriptionValue.value.trim() !== '') {
    payload.description = newDescriptionValue.value.trim();
  }
  if (newStateValue.value !== '' && newStateValue.value !== null) {
    payload.state = parseInt(newStateValue.value, 10);
  }

  btnLoadStatus.value = false;

  axios.post(`${backApi}/secure/transactions/status`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }).then(() => {
    btnLoadStatus.value = true;
    showToast("Statut mis à jour", "green");
    const modalEl = document.getElementById('changeStatusModal');
    if (modalEl) Modal.getInstance(modalEl)?.hide();

    if (search.value) {
      searchTransaction(page.value);
    } else if (search1.value) {
      searchTransaction1({ target: {} }, page.value);
    } else {
      getTransactions(page.value);
    }
  }).catch((error) => {
    btnLoadStatus.value = true;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      } else {
        errorId.value = error.response.data.errorId;
        errors.value = error.response.data.message;
        showToast(error.response.data.message, "red");
      }
    }
  });
}

function handleShowStatus(checkoutId: string) {
  closeActionMenu();
  statusLoading.value = true;
  statusDetails.value = {};

  const modalEl = document.getElementById('transactionStatusModal');
  if (!modalEl) return;

  const modalInstance = Modal.getOrCreateInstance(modalEl);

  if (!statusModalListenerAttached) {
    modalEl.addEventListener('hidden.bs.modal', handleStatusModalClosed);
    statusModalListenerAttached = true;
  }

  modalInstance.show();

  axios.get(`${backApi}/secure/transactions/${checkoutId}/status`, {
    headers: { Authorization: `Bearer ${token}` }
  }).then((response) => {
    statusDetails.value = response.data;
    statusLoading.value = false;
  }).catch((error) => {
    statusLoading.value = false;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      } else {
        showToast(error.response?.data?.message ?? "Erreur lors de la récupération du statut", "red");
      }
    }
  });
}

function handleStatusModalClosed() {
  if (search.value) {
    searchTransaction(page.value);
  } else if (search1.value) {
    searchTransaction1({ target: {} }, page.value);
  } else {
    getTransactions(page.value);
  }
}

const translatedPaymentStatus = computed(() => {
  switch (statusDetails.value.paymentStatus) {
    case 'SUCCEEDED': return t('transactions.success');
    case 'FAILED': return t('transactions.failed');
    case 'PROCESSING': return t('transactions.processing');
    case 'PENDING': return t('transactions.pending');
    default: return statusDetails.value.paymentStatus || '—';
  }
});

const statusIconClass = computed(() => {
  switch (statusDetails.value.paymentStatus) {
    case 'SUCCEEDED': return 'status-icon-success';
    case 'FAILED': return 'status-icon-failed';
    default: return 'status-icon-pending';
  }
});

const statusLabelText = computed(() => {
  switch (statusDetails.value.paymentStatus) {
    case 'SUCCEEDED': return 'Transaction réussie';
    case 'FAILED': return 'Transaction échouée';
    case 'PROCESSING': return 'Transaction en cours';
    case 'PENDING': return 'Transaction en attente';
    default: return 'Statut inconnu';
  }
});

const techStatusClass = computed(() => statusDetails.value.status === 'COMPLETED' ? 'pill-completed' : 'pill-open');

const paymentStatusClass = computed(() => {
  switch (statusDetails.value.paymentStatus) {
    case 'SUCCEEDED': return 'pill-success';
    case 'FAILED': return 'pill-failed';
    default: return 'pill-pending';
  }
});

const paymentStatusLabel = computed(() => {
  switch (statusDetails.value.paymentStatus) {
    case 'SUCCEEDED': return "Le paiement a été effectué avec succès.";
    case 'FAILED': return "Le paiement a échoué, aucun montant n'a été débité/reçu.";
    case 'PENDING': return "Le paiement est en attente de confirmation.";
    case 'PROCESSING': return "Le paiement est en cours de traitement par l'opérateur.";
    default: return "Statut de paiement non déterminé.";
  }
});

function handleGlobalClick(e: MouseEvent) {
  if (!openMenuId.value) return;
  const target = e.target as HTMLElement;
  if (target.closest('.action-menu-fixed') || target.closest('.dropdown-toggle')) {
    return;
  }
  closeActionMenu();
}

function handleGlobalScroll() {
  if (!openMenuId.value) return;
  if (Date.now() - menuOpenedAt < 300) return;
  closeActionMenu();
}

onMounted(() => {
  checkSessionValidate(1)

  getTransactions();
  getOrganizations();
  getOperators();
  getBusiness();

  setTimeout(function () {
        flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
        enableTime: true,
      });
      flatpickr("#lead-calendar-transactionDate", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
        enableTime: true,
      });
        },1000);

  flatpickr("#basic-calendar", {
    dateFormat: "Y-m-d H:i",
  });

  document.addEventListener('click', handleGlobalClick);
  document.addEventListener('scroll', handleGlobalScroll, true);
});

onBeforeUnmount(() => {
  const statusModalEl = document.getElementById('transactionStatusModal');
  if (statusModalEl) {
    statusModalEl.removeEventListener('hidden.bs.modal', handleStatusModalClosed);
  }

  document.removeEventListener('click', handleGlobalClick);
  document.removeEventListener('scroll', handleGlobalScroll, true);
});

const token =  localStorage.getItem('login_token');
const codeOrganization =  localStorage.getItem('organization_code');
const organization_name =  localStorage.getItem('organization_name');
const email =  localStorage.getItem('email');

const loadTransaction = (code)=>{

  axios.get(`${url}/${code}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        setTransactionData(response.data);
    }).catch((error) => {
      loader.value=true;
      console.error('loadTransaction error:', error);
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }

          }
  });
}

const getTransactions = (arg=1) =>{


    loader.value=false;
    gettran.value = true;
    search.value = false;
    search1.value = false;

    const todayB =  formatDateEn(new Date());
    const todayE =  formatDateEn(new Date(),1);
    axios.get(`${url}?page=${arg}&dateD=${todayB}&dateF=${todayE}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        console.log('getTransactions response:', response.data);
        transactions.value = response.data.data;
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.currentPage);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);

        loader.value=true;

    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }

          }
  });

}
const getOrganizations = () =>{

    axios.get(backApi+'/secure/organizations/',{
      headers: {

            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        organizations.value = response.data.sort((a, b) => {
          return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        });
        console.log(organizations.value);


    }).catch((error) => {
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/')
              }

          }
   });
}

const getOperators = () =>{
axios.get(backApi+'/secure/operators/available/'+process.env.VUE_APP_PAYIN_OPTTYPE,{
  headers: {

        Authorization: `Bearer ${token}`
  }
})
.then((response) => {
    operatorsTemp = response.data;

    operators.value = response.data;

    console.log(response.data);


}).catch((error) => {
      if( error.response){
          console.log(error.response.data);
          if(error.response.status === 401){
            router.push('/')

          }

      }
});
}

const exportExcelReport = (labels,fields,filename) =>{

  import("../../../utils/Export2Excel").then((excel)=>{

    const dataForExcel= formatJSon(fields,data);
    excel.export_json_to_excel({
      header:labels,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:filename,
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

const exportExcelReportOld = () =>{

  import("../../../utils/Export2Excel").then((excel)=>{
    const Header =["CODE TRANSACTION","DATE OPERATION","OPERATEUR","MONTANT","TYPE OPERATION","BALANCE","STATUT"];
    const Fields = ["checkoutId","transactionDate","status","amount","operationType","","paymentStatus"];
    const dataForExcel= formatJSon(Fields,data);
    excel.export_json_to_excel({
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"report",
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

const exportExcel = () =>{

  import("../../../utils/Export2Excel").then((excel)=>{
    const Header =["CODE TRANSACTION","OPERATEUR","DESCRIPTION","TELEPHONE","MONTANT","DATE","STATUT"];
    const Fields = ["checkoutId","operator_name","description","contact","amount","transactionDate","paymentStatus"];
    const dataForExcel= formatJSon(Fields,data);
    excel.export_json_to_excel({
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"transactions",
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

const exportToPDF = () =>{
  searchTransactionExportToPDF()

  setTimeout(() => {

        document.getElementById("transactionsTable").style.display='block';
        const opt ={margin: [0, 0, 0, 0],filename: "transactions.pdf",jsPDF:{ unit: 'mm', format: 'a4', orientation: 'portrait',putOnlyUsedFonts:true,floatPrecision: "smart"  },image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2 },}

      html2pdf().set(opt).from(document.getElementById("transactionsTable")).toPdf().get('pdf').then(function (pdf) {

      window.open(pdf.output('bloburl'), '_blank');
      document.getElementById("transactionsTable").style.display='none';
      });

    }, 3000);


}

const searchTransactionExportToPDF = ()=>{
   btnLoad1.value=false;

  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date());
  }

  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1);
  }

    const todayE =  formatDateEn(new Date(endDate.value),1);
    const extraFilters = buildFilterQuery();
    const operationTypeValue = resolveOperationType();
  axios.get(`${url}/list/export?dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operatorMno=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${operationTypeValue}&business=${selectedBusiness.value}&contact=${phone_number.value}${extraFilters ? '&' + extraFilters : ''}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {

        if(response.status === 200){
           transaction1s.value  = response.data;
           btnLoad1.value=true;
        }
    }).catch((error) => {
      btnLoad1.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              } else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;

              }

          }
  });
}

function formatJSon(FilterData,JsonData){
  return JsonData.map((v)=>FilterData.map(j=>{
      return v[j];
    }));
}


const searchTransaction = (arg=1)=>{
  loader.value=false;
  gettran.value = false;
  search.value = true;
  search1.value = false;

  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date());
  }

  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1);
  }
    const todayE =  formatDateEn(new Date(endDate.value),1);
    const extraFilters = buildFilterQuery();
    const operationTypeValue = resolveOperationType();
  axios.get(`${url}?page=${arg}&dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operatorMno=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${operationTypeValue}&business=${selectedBusiness.value}&contact=${phone_number.value}${extraFilters ? '&' + extraFilters : ''}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        console.log('searchTransaction response:', response.data);
        transactions.value = response.data.data;
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.currentPage);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        loader.value=true;

    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }

          }
  });
}
const searchTransaction1 = (event,arg=1)=>{
   if(typeof event.target.value!=='undefined'){
    today.value = event.target.value
   }

    loader.value=false;
    gettran.value = false;
    search.value = false;
    search1.value = true;

    const todayE =  formatDateEn(new Date(today.value),1);
  axios.get(`${url}?page=${arg}&dateD=${today.value}&dateF=${todayE}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        console.log('searchTransaction1 response:', response.data);
        transactions.value = response.data.data;
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.currentPage);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        loader.value=true;

    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }

          }
  });
}

const searchTransactionForExport = ()=>{
   btnLoad.value=false;

  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date());
  }

  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1);
  }

    const todayE =  formatDateEn(new Date(endDate.value),1);
    const extraFilters = buildFilterQuery();
    const operationTypeValue = resolveOperationType();
  axios.get(`${url}/list/export?dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operatorMno=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${operationTypeValue}&business=${selectedBusiness.value}&contact=${phone_number.value}${extraFilters ? '&' + extraFilters : ''}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        if(response.status === 200){
        data  = response.data;

        for (let pas = 0; pas < data.length; pas++) {
          data[pas].operator_name = data[pas].operator.mnoName;
        }

        exportExcel()
        btnLoad.value=true;
      }
    }).catch((error) => {
      btnLoad.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              } else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;

              }

          }
  });
}

const reportForExport = ()=>{
   btnLoad.value=false;

  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date());
  }

  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1);
  }
    const todayE =  formatDateEn(new Date(endDate.value),1);
  axios.post(`${backApi}/secure/organizations/report`,
       {
         start:beginDate.value,
         end:todayE,
          organization:selectedOrganization.value
        },
        {
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        if(response.status === 200){
        data  = response.data.transactions;
        console.log(data)

        for (let pas = 0; pas < data.length; pas++) {
          data[pas].operationType = (data[pas].operationType=="1")?"Payin":"Payout";
          data[pas].balance = parseFloat(data[pas].collectBalance-(data[pas].payoutBalance-data[pas].topupBalance));
        }

        const Header =["CODE TRANSACTION","DATE OPERATION","OPERATEUR","MONTANT","TYPE OPERATION","BALANCE","STATUT"];
        const Fields = ["checkoutId","transactionDate","status","amount","operationType","","paymentStatus"];

        exportExcelReport(Header,Fields,"report");
        btnLoad.value=true;
      }
    }).catch((error) => {
      btnLoad.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              } else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;

              }

          }
  });
}

const showScreen = (screen)=>{
  screenSelected.value=screen
  selectedBusiness.value='';
  selectedOperator.value='';
  selectedStatus.value='';

  // Réinitialiser sur l'onglet principal
  activeFilterTab.value = 'base';

  const element = document.querySelector('input');
  const event = new KeyboardEvent('keydown', {'key': '65'});
  element.dispatchEvent(event);
}

const getBusiness = (arg=1) =>{
    let param = '';
    param = `?organization=${codeOrganization}`
    axios.get(backApi+'/secure/business/'+param,{
      headers: {

            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        data  = response.data;
        businessTemp = response.data;
        getBusinessParent(businessTemp)

    }).catch((error) => {
          if( error.response){
              if(error.response.status === 401){
                router.push('/')

              }

          }
  });
}

const getBusinessParent = (businessParents) =>{
  var j = 0;
  var businessArr = new Array<Business>();
  while(j<businessParents.length){
      if(businessParents[j].parent == null){
        businessArr.push(businessParents[j]);
      }
      j++;
  }
  business.value = businessArr;
}

function handleBusinessChange(event) {
      selectedBusiness.value = event.target.value;
      subBusiness.value = [];
      var j = 0;
      var businessArr = new Array<Business>();
      while(j<businessTemp.length){
          if(businessTemp[j].parent?.code == event.target.value){
            businessArr.push(businessTemp[j]);
          }
          j++;
      }

      if(businessArr.length>0){
        subBusiness.value = businessArr;
        document.getElementById("container_sub_business").style.display='block';
        document.getElementById("sub_business1").style.display='block';

      }else{
        document.getElementById("container_sub_business").style.display='none';
        document.getElementById("sub_business1").style.display='none';
      }

}

function handleSubBusinessChange(event) {
      selectedBusiness.value = event.target.value;
}

const download_receipt = (payoutId) => {
  var event;
  loadTransaction(payoutId)

  const element = PDFReceipt.value;
  element.classList.remove("d-none");


  document.getElementById("back").classList.add("d-none");
  setTimeout(() => {


    document.getElementById("receipt").style.display = 'block';

    const opt = {
      margin: [0, 0, 0, 0], filename: "receipt_" + transaction.value.payoutId + ".pdf", jsPDF: { unit: 'mm', format: 'a5', orientation: 'portrait', putOnlyUsedFonts: true, floatPrecision: "smart" }, image: { type: 'jpeg', quality: 0.98 },

      html2canvas: { scale: 2 },
    }
    html2pdf().set(opt).from(document.getElementById("receipt")).toPdf().save()

  }, 3000);
  setTimeout(() => {
    element.classList.add("d-none");
    document.getElementById("back").classList.remove("d-none");
  }, 3000);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[67] || (_cache[67] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_unref(current_permissions)('export_transactions'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-outline-btn position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                    type: "button",
                    style: {"background-color":"#EB9355"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showScreen('excel'))),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#filterLeadModal"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('transactions.export')) + " ", 1),
                    _cache[68] || (_cache[68] = _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1))
                  ]))
                : _createCommentVNode("", true),
              _cache[69] || (_cache[69] = _createTextVNode("      ", -1)),
              (_unref(current_permissions)('create_public_token'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t('transactions.link')), 1),
                    (_unref(environment)=='PROD')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('transactions.payment')), 1))
                      : _createCommentVNode("", true),
                    (_unref(environment)=='DEMO')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('transactions.collection')), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(today) ? (today).value = $event : today = $event)),
                    type: "date",
                    class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                    id: "lead-calendar",
                    placeholder: leadPlaceholder,
                    onChange: searchTransaction1
                  }, null, 544), [
                    [_vModelText, _unref(today)]
                  ])
                ])
              ]),
              (_unref(current_permissions)('get_public_checkout'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#filterLeadModal",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showScreen('search')))
                  }, [...(_cache[70] || (_cache[70] = [
                    _createElementVNode("svg", {
                      width: "25",
                      height: "25",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('transactions.code')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('transactions.operator')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('transactions.description')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('transactions.phone')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('transactions.amount')), 1),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('transactions.date')), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('transactions.status')), 1),
                    _cache[71] || (_cache[71] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (transaction) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: transaction.checkoutId
                    }, [
                      _createElementVNode("th", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("span", _hoisted_23, [
                              (transaction.publicToken!=null)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(transaction.checkoutId), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(transaction.operator.mnoName), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(transaction.description), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(transaction.contact), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(transaction.amount.toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(formatDateFr(new Date(transaction.transactionDate))), 1),
                      _createElementVNode("td", _hoisted_31, [
                        (transaction.paymentStatus==='SUCCEEDED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('transactions.success')), 1))
                          : _createCommentVNode("", true),
                        (transaction.paymentStatus==='FAILED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('transactions.failed')), 1))
                          : _createCommentVNode("", true),
                        (transaction.paymentStatus==='PROCESSING')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t('transactions.processing')), 1))
                          : _createCommentVNode("", true),
                        (transaction.paymentStatus==='PENDING')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('transactions.pending')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_36, [
                        _createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          onClick: ($event: any) => (toggleActionMenu($event, transaction.checkoutId))
                        }, [...(_cache[72] || (_cache[72] = [
                          _createElementVNode("i", { class: "flaticon-dots" }, null, -1)
                        ]))], 8, _hoisted_37)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(organization_name)), 1),
                  _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('transactions.editionDate')), 1),
                  _createElementVNode("span", _hoisted_41, _toDisplayString(formatDateFr(new Date())), 1),
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(email)), 1)
                ]),
                _cache[77] || (_cache[77] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("h2", _hoisted_44, [
                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('transactions.listTitle')), 1),
                    _createElementVNode("span", _hoisted_46, [
                      _createTextVNode(_toDisplayString(_ctx.$t('transactions.period')) + " ", 1),
                      _createElementVNode("span", _hoisted_47, _toDisplayString(formatDateFr(new Date((_unref(beginDate))))), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('transactions.to')) + " ", 1),
                      _createElementVNode("span", _hoisted_48, _toDisplayString(formatDateFr(new Date((_unref(endDate))))), 1)
                    ])
                  ])
                ]),
                _cache[78] || (_cache[78] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("table", _hoisted_50, [
                    _createElementVNode("thead", _hoisted_51, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.$t('transactions.code')), 1),
                        _createElementVNode("th", _hoisted_53, _toDisplayString(_ctx.$t('transactions.operator')), 1),
                        _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.$t('transactions.description')), 1),
                        _createElementVNode("th", _hoisted_55, _toDisplayString(_ctx.$t('transactions.phone')), 1),
                        _createElementVNode("th", _hoisted_56, _toDisplayString(_ctx.$t('transactions.amount')), 1),
                        _createElementVNode("th", _hoisted_57, _toDisplayString(_ctx.$t('transactions.date')), 1),
                        _createElementVNode("th", _hoisted_58, _toDisplayString(_ctx.$t('transactions.status')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transaction1s.value, (transaction1) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: transaction1.checkoutId
                        }, [
                          _createElementVNode("td", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, _toDisplayString(transaction1.checkoutId), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_62, [
                            _createElementVNode("span", null, _toDisplayString(transaction1.operator.mnoName), 1)
                          ]),
                          _createElementVNode("td", _hoisted_63, [
                            _createElementVNode("span", null, _toDisplayString(transaction1.description), 1)
                          ]),
                          _createElementVNode("td", _hoisted_64, _toDisplayString(transaction1.contact), 1),
                          _createElementVNode("td", _hoisted_65, [
                            _createElementVNode("span", null, _toDisplayString(transaction1.amount.toLocaleString()), 1)
                          ]),
                          _createElementVNode("td", _hoisted_66, _toDisplayString(formatDateFr(new Date(transaction1.transactionDate))), 1),
                          _createElementVNode("td", _hoisted_67, [
                            (transaction1.paymentStatus==='FAILED')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_68, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('transactions.failed')) + " ", 1),
                                  _cache[73] || (_cache[73] = _createElementVNode("img", {
                                    src: _imports_0,
                                    alt: "logo-icon",
                                    style: {"max-width":"25%"}
                                  }, null, -1))
                                ]))
                              : _createCommentVNode("", true),
                            (transaction1.paymentStatus==='SUCCEEDED')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('transactions.success')) + " ", 1),
                                  _cache[74] || (_cache[74] = _createElementVNode("img", {
                                    src: _imports_1,
                                    alt: "logo-icon",
                                    style: {"max-width":"25%"}
                                  }, null, -1))
                                ]))
                              : _createCommentVNode("", true),
                            (transaction1.paymentStatus==='PROCESSING')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_70, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('transactions.processing')) + " ", 1),
                                  _cache[75] || (_cache[75] = _createElementVNode("img", {
                                    src: _imports_2,
                                    alt: "logo-icon",
                                    style: {"max-width":"25%"}
                                  }, null, -1))
                                ]))
                              : _createCommentVNode("", true),
                            (transaction1.paymentStatus==='PENDING')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('transactions.pending')) + " ", 1),
                                  _cache[76] || (_cache[76] = _createElementVNode("img", {
                                    src: _imports_2,
                                    alt: "logo-icon",
                                    style: {"max-width":"25%"}
                                  }, null, -1))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            (total.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  (total.value>10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_73, [
                        _createTextVNode(_toDisplayString(_ctx.$t('transactions.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_74, _toDisplayString(page.value*10), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('transactions.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_75, _toDisplayString(total.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('transactions.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (total.value<=10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_76, [
                        _createTextVNode(_toDisplayString(_ctx.$t('transactions.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_77, _toDisplayString(total.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('transactions.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_78, _toDisplayString(total.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('transactions.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (gettran.value==true)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_79, [
                        _createElementVNode("ul", _hoisted_80, [
                          ((page.value-1)>0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_81, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (getTransactions(page.value-1))),
                                  "aria-label": "Previous"
                                }, [...(_cache[79] || (_cache[79] = [
                                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: numPage,
                              class: "page-item"
                            }, [
                              (numPage==page.value)
                                ? (_openBlock(), _createElementBlock("a", _hoisted_82, _toDisplayString(numPage), 1))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "page-link",
                                    onClick: ($event: any) => (getTransactions(numPage))
                                  }, _toDisplayString(numPage), 9, _hoisted_83))
                            ]))
                          }), 128)),
                          ((page.value+1)<=numPages.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_84, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (getTransactions(page.value+1))),
                                  "aria-label": "Next"
                                }, [...(_cache[80] || (_cache[80] = [
                                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (search.value==true)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_85, [
                        _createElementVNode("ul", _hoisted_86, [
                          ((page.value-1)>0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_87, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (searchTransaction(page.value-1))),
                                  "aria-label": "Previous"
                                }, [...(_cache[81] || (_cache[81] = [
                                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: numPage,
                              class: "page-item"
                            }, [
                              (numPage==page.value)
                                ? (_openBlock(), _createElementBlock("a", _hoisted_88, _toDisplayString(numPage), 1))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "page-link",
                                    onClick: ($event: any) => (searchTransaction(numPage))
                                  }, _toDisplayString(numPage), 9, _hoisted_89))
                            ]))
                          }), 128)),
                          ((page.value+1)<=numPages.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_90, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (searchTransaction(page.value+1))),
                                  "aria-label": "Next"
                                }, [...(_cache[82] || (_cache[82] = [
                                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (search1.value==true)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_91, [
                        _createElementVNode("ul", _hoisted_92, [
                          ((page.value-1)>0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_93, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (searchTransaction1($event,page.value-1))),
                                  "aria-label": "Previous"
                                }, [...(_cache[83] || (_cache[83] = [
                                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: numPage,
                              class: "page-item"
                            }, [
                              (numPage==page.value)
                                ? (_openBlock(), _createElementBlock("a", _hoisted_94, _toDisplayString(numPage), 1))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "page-link",
                                    onClick: ($event: any) => (searchTransaction1($event,numPage))
                                  }, _toDisplayString(numPage), 9, _hoisted_95))
                            ]))
                          }), 128)),
                          ((page.value+1)<=numPages.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_96, [
                                _createElementVNode("a", {
                                  class: "page-link",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (searchTransaction1($event,page.value+1))),
                                  "aria-label": "Next"
                                }, [...(_cache[84] || (_cache[84] = [
                                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (openMenuId.value)
        ? (_openBlock(), _createElementBlock("ul", {
            key: 0,
            class: "dropdown-menu show action-menu-fixed",
            style: _normalizeStyle({ top: menuPosition.value.top + 'px', left: menuPosition.value.left + 'px' }),
            onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (handleView(openMenuId.value))),
                href: "javascript:void(0);",
                class: "dropdown-item d-flex align-items-center"
              }, [
                _cache[85] || (_cache[85] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('transactions.view')), 1)
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (handleReceipt(openMenuId.value))),
                href: "javascript:void(0);",
                class: "dropdown-item d-flex align-items-center"
              }, [
                _cache[86] || (_cache[86] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('transactions.receipt')), 1)
              ])
            ]),
            isSuperAdmin
              ? (_openBlock(), _createElementBlock("li", _hoisted_97, [
                  _createElementVNode("a", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (handleShowStatus(openMenuId.value))),
                    href: "javascript:void(0);",
                    class: "dropdown-item d-flex align-items-center"
                  }, [...(_cache[87] || (_cache[87] = [
                    _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                    _createTextVNode(" Statut réel ", -1)
                  ]))])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                target: "_blank",
                class: "dropdown-item d-flex align-items-center",
                href: "https://wa.me/message/SV5FPBLDUDCBJ1",
                onClick: closeActionMenu
              }, [
                _cache[88] || (_cache[88] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('transactions.claim')), 1)
              ])
            ]),
            isSuperAdmin
              ? (_openBlock(), _createElementBlock("li", _hoisted_98, [
                  _createElementVNode("a", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (handleChangeStatus(openMenuId.value))),
                    href: "javascript:void(0);",
                    class: "dropdown-item d-flex align-items-center"
                  }, [...(_cache[89] || (_cache[89] = [
                    _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                    _createTextVNode(" Changer statut ", -1)
                  ]))])
                ]))
              : _createCommentVNode("", true)
          ], 4))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", _hoisted_99, [
      _createElementVNode("div", _hoisted_100, [
        _createElementVNode("div", _hoisted_101, [
          _createElementVNode("div", _hoisted_102, [
            (screenSelected.value=='search')
              ? (_openBlock(), _createElementBlock("h1", _hoisted_103, _toDisplayString(_ctx.$t('transactions.advancedSearch')), 1))
              : _createCommentVNode("", true),
            (screenSelected.value=='excel')
              ? (_openBlock(), _createElementBlock("h1", _hoisted_104, _toDisplayString(_ctx.$t('transactions.exportExcel')), 1))
              : _createCommentVNode("", true),
            _cache[90] || (_cache[90] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["modal-tab", { active: activeFilterTab.value === 'base' }]),
              onClick: _cache[14] || (_cache[14] = ($event: any) => (activeFilterTab.value = 'base'))
            }, [
              _cache[91] || (_cache[91] = _createTextVNode(" Critères de recherche ", -1)),
              (activeBaseFiltersCount.value > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(activeBaseFiltersCount.value), 1))
                : _createCommentVNode("", true)
            ], 2),
            (_unref(isPrivilegedRole))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: _normalizeClass(["modal-tab", { active: activeFilterTab.value === 'advanced' }]),
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (activeFilterTab.value = 'advanced'))
                }, [
                  _cache[92] || (_cache[92] = _createTextVNode(" Filtres avancés ", -1)),
                  (activeAdvancedFiltersCount.value > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_107, _toDisplayString(activeAdvancedFiltersCount.value), 1))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_108, [
            (errors.value!=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                  _createElementVNode("h6", _hoisted_110, "code: " + _toDisplayString(errorId.value), 1),
                  _createElementVNode("h6", _hoisted_111, _toDisplayString(errors.value), 1)
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_112, [
                (_unref(current_permissions)('SUPERADMIN'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                      _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.$t('transactions.clients')), 1),
                      _createElementVNode("select", {
                        name: "organization",
                        id: "organization",
                        class: "form-select fs-md-15 text-black shadow-none",
                        onChange: handleOrganizationChange,
                        required: ""
                      }, [
                        _createElementVNode("option", _hoisted_115, _toDisplayString(_ctx.$t('transactions.select')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: organization.code,
                            key: organization.id
                          }, _toDisplayString(organization.name), 9, _hoisted_116))
                        }), 128))
                      ], 32)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(current_permissions)('SUPERADMIN-ADMIN-USER'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                      _createElementVNode("label", _hoisted_118, _toDisplayString(_ctx.$t('transactions.country')), 1),
                      _createElementVNode("select", {
                        name: "organization",
                        id: "organization",
                        class: "form-select fs-md-15 text-black shadow-none",
                        onChange: handleCountryChange,
                        required: ""
                      }, [
                        _createElementVNode("option", _hoisted_119, _toDisplayString(_ctx.$t('transactions.select')), 1),
                        _createElementVNode("option", _hoisted_120, _toDisplayString(_ctx.$t('transactions.senegal')), 1),
                        _createElementVNode("option", _hoisted_121, _toDisplayString(_ctx.$t('transactions.ivoryCoast')), 1)
                      ], 32)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_122, [
                  _createElementVNode("label", _hoisted_123, _toDisplayString(_ctx.$t('transactions.operators')), 1),
                  _createElementVNode("select", {
                    name: "operator",
                    id: "operator",
                    class: "form-select fs-md-15 text-black shadow-none",
                    onChange: handleOperatorChange,
                    required: ""
                  }, [
                    _createElementVNode("option", _hoisted_124, _toDisplayString(_ctx.$t('transactions.select')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operators.value, (operator) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: operator.id,
                        key: operator.code
                      }, _toDisplayString(operator.mnoName), 9, _hoisted_125))
                    }), 128))
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("label", _hoisted_127, _toDisplayString(_ctx.$t('transactions.statuses')), 1),
                  _createElementVNode("select", {
                    name: "status",
                    id: "status",
                    class: "form-select fs-md-15 text-black shadow-none",
                    onChange: handleStatusChange,
                    required: ""
                  }, [
                    _createElementVNode("option", _hoisted_128, _toDisplayString(_ctx.$t('transactions.select')), 1),
                    _createElementVNode("option", _hoisted_129, _toDisplayString(_ctx.$t('transactions.success')), 1),
                    _createElementVNode("option", _hoisted_130, _toDisplayString(_ctx.$t('transactions.processing')), 1),
                    _createElementVNode("option", _hoisted_131, _toDisplayString(_ctx.$t('transactions.pending')), 1),
                    _createElementVNode("option", _hoisted_132, _toDisplayString(_ctx.$t('transactions.failed')), 1)
                  ], 32)
                ])
              ]),
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.$t('transactions.startDate')), 1),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(beginDate) ? (beginDate).value = $event : beginDate = $event)),
                      type: "text",
                      class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      id: "lead-calendar",
                      placeholder: leadPlaceholder
                    }, null, 512), [
                      [_vModelText, _unref(beginDate)]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_136, [
                  _createElementVNode("label", _hoisted_137, _toDisplayString(_ctx.$t('transactions.endDate')), 1),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(endDate) ? (endDate).value = $event : endDate = $event)),
                      type: "text",
                      class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                      id: "lead-calendar",
                      placeholder: leadPlaceholder
                    }, null, 512), [
                      [_vModelText, _unref(endDate)]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("label", _hoisted_139, _toDisplayString(_ctx.$t('transactions.category')), 1),
                  _createElementVNode("select", {
                    name: "business",
                    id: "business",
                    class: "form-select fs-md-15 text-black shadow-none",
                    onChange: handleBusinessChange,
                    required: ""
                  }, [
                    _createElementVNode("option", _hoisted_140, _toDisplayString(_ctx.$t('transactions.select')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(business.value, (businessItem) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: businessItem.code,
                        key: businessItem.code
                      }, _toDisplayString(businessItem.name), 9, _hoisted_141))
                    }), 128))
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_142, [
                  _createElementVNode("label", _hoisted_143, _toDisplayString(_ctx.$t('transactions.subCategory')), 1),
                  _createElementVNode("select", {
                    name: "sub_business1",
                    id: "sub_business1",
                    class: "form-select fs-md-15 text-black shadow-none sub_business",
                    onChange: handleSubBusinessChange
                  }, [
                    _createElementVNode("option", _hoisted_144, _toDisplayString(_ctx.$t('transactions.selectSubCategory')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subBusiness.value, (subBusinessItem) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: subBusinessItem.code,
                        key: subBusinessItem.code
                      }, _toDisplayString(subBusinessItem.name), 9, _hoisted_145))
                    }), 128))
                  ], 32)
                ])
              ]),
              _createElementVNode("div", _hoisted_146, [
                _createElementVNode("div", _hoisted_147, [
                  _createElementVNode("label", _hoisted_148, _toDisplayString(_ctx.$t('transactions.phoneNumber')), 1),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      onKeyup: _cache[18] || (_cache[18] = ($event: any) => (_unref(validate_phone_number)($event.target.value,$event.target))),
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(phone_number) ? (phone_number).value = $event : phone_number = $event)),
                      type: "text",
                      class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                    }, null, 544), [
                      [_vModelText, _unref(phone_number)]
                    ])
                  ])
                ])
              ])
            ], 512), [
              [_vShow, activeFilterTab.value === 'base']
            ]),
            (_unref(isPrivilegedRole))
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_149, [
                  _createElementVNode("div", _hoisted_150, [
                    _createElementVNode("div", _hoisted_151, [
                      _cache[93] || (_cache[93] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Code", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((filterCode).value = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterCode.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_152, [
                      _cache[94] || (_cache[94] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "(Checkout ID)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((filterCheckoutId).value = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterCheckoutId.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_153, [
                      _cache[95] || (_cache[95] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Payout ID", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((filterPayoutId).value = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterPayoutId.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_154, [
                      _cache[96] || (_cache[96] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Référence client", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((filterClientReference).value = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterClientReference.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_155, [
                    _createElementVNode("div", _hoisted_156, [
                      _cache[97] || (_cache[97] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "ID client", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((filterClientId).value = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterClientId.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_157, [
                      _cache[98] || (_cache[98] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Description", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((filterDescription).value = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterDescription.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_158, [
                      _cache[99] || (_cache[99] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Token public", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((filterPublicToken).value = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterPublicToken.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_159, [
                      _cache[100] || (_cache[100] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "État", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((filterState).value = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterState.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_160, [
                    _createElementVNode("div", _hoisted_161, [
                      _cache[101] || (_cache[101] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Utilisateur (code)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((filterUser).value = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterUser.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_162, [
                      _cache[102] || (_cache[102] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Montant exact", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((filterAmount).value = $event)),
                        type: "number",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterAmount.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_163, [
                      _cache[103] || (_cache[103] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Montant min", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((filterMinAmount).value = $event)),
                        type: "number",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterMinAmount.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_164, [
                      _cache[104] || (_cache[104] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Montant max", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((filterMaxAmount).value = $event)),
                        type: "number",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterMaxAmount.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_165, [
                    _createElementVNode("div", _hoisted_166, [
                      _cache[105] || (_cache[105] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "ID Bulk interne", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((filterIntBulkId).value = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterIntBulkId.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_167, [
                      _cache[106] || (_cache[106] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "ID Bulk opérateur", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((filterIntOperatorBulkId).value = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterIntOperatorBulkId.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_168, [
                      _cache[107] || (_cache[107] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Bulk ID", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((filterBulkId).value = $event)),
                        type: "text",
                        class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      }, null, 512), [
                        [_vModelText, filterBulkId.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_169, [
                      _cache[108] || (_cache[108] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Type d'opération", -1)),
                      _createElementVNode("select", {
                        name: "filterOperationType",
                        id: "filterOperationType",
                        class: "form-select fs-md-15 text-black shadow-none",
                        onChange: handleFilterOperationTypeChange
                      }, [
                        _createElementVNode("option", _hoisted_170, _toDisplayString(_ctx.$t('transactions.select')), 1),
                        _createElementVNode("option", _hoisted_171, _toDisplayString(_ctx.$t('transactions.payin')), 1),
                        _createElementVNode("option", _hoisted_172, _toDisplayString(_ctx.$t('transactions.payout')), 1)
                      ], 32)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_173, [
                    _createElementVNode("div", _hoisted_174, [
                      _cache[109] || (_cache[109] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Date de transaction", -1)),
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((filterTransactionDate).value = $event)),
                          type: "text",
                          class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                          id: "lead-calendar-transactionDate",
                          placeholder: leadPlaceholder
                        }, null, 512), [
                          [_vModelText, filterTransactionDate.value]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_175, [
                      _cache[112] || (_cache[112] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Type de payout", -1)),
                      _createElementVNode("select", {
                        name: "filterPayoutType",
                        id: "filterPayoutType",
                        class: "form-select fs-md-15 text-black shadow-none",
                        onChange: handleFilterPayoutTypeChange
                      }, [
                        _createElementVNode("option", _hoisted_176, _toDisplayString(_ctx.$t('transactions.select')), 1),
                        _cache[110] || (_cache[110] = _createElementVNode("option", { value: "1" }, "Single", -1)),
                        _cache[111] || (_cache[111] = _createElementVNode("option", { value: "2" }, "Bulk", -1))
                      ], 32)
                    ]),
                    _createElementVNode("div", _hoisted_177, [
                      _cache[116] || (_cache[116] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Statut de validation", -1)),
                      _createElementVNode("select", {
                        name: "filterValidationStatus",
                        id: "filterValidationStatus",
                        class: "form-select fs-md-15 text-black shadow-none",
                        onChange: handleFilterValidationStatusChange
                      }, [
                        _createElementVNode("option", _hoisted_178, _toDisplayString(_ctx.$t('transactions.select')), 1),
                        _cache[113] || (_cache[113] = _createElementVNode("option", { value: "DRAFT" }, "DRAFT", -1)),
                        _cache[114] || (_cache[114] = _createElementVNode("option", { value: "VALIDATED" }, "VALIDATED", -1)),
                        _cache[115] || (_cache[115] = _createElementVNode("option", { value: "REJECTED" }, "REJECTED", -1))
                      ], 32)
                    ]),
                    _createElementVNode("div", _hoisted_179, [
                      _cache[120] || (_cache[120] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Statut validation TP", -1)),
                      _createElementVNode("select", {
                        name: "filterPublicTokenValidationStatus",
                        id: "filterPublicTokenValidationStatus",
                        class: "form-select fs-md-15 text-black shadow-none",
                        onChange: handleFilterPublicTokenValidationStatusChange
                      }, [
                        _createElementVNode("option", _hoisted_180, _toDisplayString(_ctx.$t('transactions.select')), 1),
                        _cache[117] || (_cache[117] = _createElementVNode("option", { value: "DRAFT" }, "DRAFT", -1)),
                        _cache[118] || (_cache[118] = _createElementVNode("option", { value: "VALIDATED" }, "VALIDATED", -1)),
                        _cache[119] || (_cache[119] = _createElementVNode("option", { value: "REJECTED" }, "REJECTED", -1))
                      ], 32)
                    ])
                  ])
                ], 512)), [
                  [_vShow, activeFilterTab.value === 'advanced']
                ])
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_181, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: resetAdvancedFilters
            }, " Réinitialiser les filtres "),
            (screenSelected.value=='search')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn",
                  style: {"background-color":"#EB9355"},
                  "data-bs-dismiss": "modal",
                  onClick: _cache[36] || (_cache[36] = ($event: any) => (searchTransaction(1)))
                }, [...(_cache[121] || (_cache[121] = [
                  _createElementVNode("i", {
                    class: "flaticon-search-interface-symbol",
                    style: {"color":"#FFF"}
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
            (screenSelected.value=='excel')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: !btnLoad.value,
                  type: "button",
                  class: "btn",
                  style: {"background-color":"#EB9355"},
                  onClick: _cache[37] || (_cache[37] = ($event: any) => (searchTransactionForExport()))
                }, [
                  (!btnLoad.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_183))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_184, _toDisplayString(_ctx.$t('transactions.excel')), 1)
                ], 8, _hoisted_182))
              : _createCommentVNode("", true),
            (screenSelected.value=='excel')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  disabled: !btnLoad1.value,
                  type: "button",
                  class: "btn",
                  style: {"background-color":"blue"},
                  onClick: _cache[38] || (_cache[38] = ($event: any) => (exportToPDF()))
                }, [
                  (!btnLoad1.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_186))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_187, _toDisplayString(_ctx.$t('transactions.pdf')), 1)
                ], 8, _hoisted_185))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_188, [
      _createElementVNode("div", _hoisted_189, [
        _createElementVNode("div", _hoisted_190, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_191, [
              _createElementVNode("h1", _hoisted_192, _toDisplayString(_ctx.$t('transactions.transactionDetails')) + " (" + _toDisplayString(paymentStatus.value) + ")", 1),
              _cache[122] || (_cache[122] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_193, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["modal-tab", { active: activeDetailTab.value === 'main' }]),
                onClick: _cache[39] || (_cache[39] = ($event: any) => (activeDetailTab.value = 'main'))
              }, " Informations principales ", 2),
              (_unref(isPrivilegedRole))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["modal-tab", { active: activeDetailTab.value === 'advanced' }]),
                    onClick: _cache[40] || (_cache[40] = ($event: any) => (activeDetailTab.value = 'advanced'))
                  }, " Informations avancées ", 2))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_194, [
              _createElementVNode("div", _hoisted_195, [
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_196, [
                    (hasValue(transaction.value.checkoutId))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                          _createElementVNode("label", _hoisted_198, _toDisplayString(_ctx.$t('transactions.transactionCode')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((transaction.value.checkoutId) = $event)),
                            type: "text",
                            class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, transaction.value.checkoutId]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (transaction.value.paymentStatus==='SUCCEEDED' && hasValue(transaction.value.operator?.mnoName==='WAVE' ? transaction.value.providerTransactionId : transaction.value.providerTransactionReference))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                          _createElementVNode("label", _hoisted_200, _toDisplayString(_ctx.$t('transactions.operatorReference')), 1),
                          (transaction.value.operator?.mnoName!=='WAVE')
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((transaction.value.providerTransactionReference) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512)), [
                                [_vModelText, transaction.value.providerTransactionReference]
                              ])
                            : _createCommentVNode("", true),
                          (transaction.value.operator?.mnoName=='WAVE')
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((transaction.value.providerTransactionId) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512)), [
                                [_vModelText, transaction.value.providerTransactionId]
                              ])
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (hasValue(_unref(amount)))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                          _createElementVNode("label", _hoisted_202, _toDisplayString(_ctx.$t('transactions.amount')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_isRef(amount) ? (amount).value = $event : amount = $event)),
                            type: "text",
                            class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, _unref(amount)]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (hasValue(transaction.value.transactionDate))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                          _createElementVNode("label", _hoisted_204, _toDisplayString(_ctx.$t('transactions.date')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((transaction.value.transactionDate) = $event)),
                            type: "text",
                            class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, transaction.value.transactionDate]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (hasValue(operator.value))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                          _createElementVNode("label", _hoisted_206, _toDisplayString(_ctx.$t('transactions.operator')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((operator).value = $event)),
                            type: "text",
                            class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, operator.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (hasValue(transaction.value.contact))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                          _createElementVNode("label", _hoisted_208, _toDisplayString(_ctx.$t('transactions.phone')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((transaction.value.contact) = $event)),
                            type: "text",
                            class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, transaction.value.contact]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 512), [
                  [_vShow, activeDetailTab.value === 'main']
                ]),
                (_unref(isPrivilegedRole))
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_209, [
                      _createElementVNode("div", _hoisted_210, [
                        (hasValue(transaction.value.payoutId))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                              _createElementVNode("label", _hoisted_212, _toDisplayString(_ctx.$t('transactions.payoutId')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((transaction.value.payoutId) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.payoutId]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.bulkId))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
                              _createElementVNode("label", _hoisted_214, _toDisplayString(_ctx.$t('transactions.bulkId')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((transaction.value.bulkId) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.bulkId]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.status))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_215, [
                              _createElementVNode("label", _hoisted_216, _toDisplayString(_ctx.$t('transactions.technicalStatus')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.status,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_217)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.validationStatus))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                              _createElementVNode("label", _hoisted_219, _toDisplayString(_ctx.$t('transactions.validationStatus')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.validationStatus,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_220)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.statusCode))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                              _createElementVNode("label", _hoisted_222, _toDisplayString(_ctx.$t('transactions.statusCode')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.statusCode,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_223)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.operationType))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                              _createElementVNode("label", _hoisted_225, _toDisplayString(_ctx.$t('transactions.operationType')), 1),
                              _createElementVNode("input", {
                                value: String(transaction.value.operationType)==='1' ? _ctx.$t('transactions.payin') : (String(transaction.value.operationType)==='2' ? _ctx.$t('transactions.payout') : transaction.value.operationType),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_226)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.currency))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                              _createElementVNode("label", _hoisted_228, _toDisplayString(_ctx.$t('transactions.currency')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((transaction.value.currency) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.currency]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.countryCode))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_229, [
                              _createElementVNode("label", _hoisted_230, _toDisplayString(_ctx.$t('transactions.countryCode')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((transaction.value.countryCode) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.countryCode]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.totalFees))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_231, [
                              _createElementVNode("label", _hoisted_232, _toDisplayString(_ctx.$t('transactions.totalFees')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.totalFees,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_233)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.imoneyFees))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_234, [
                              _createElementVNode("label", _hoisted_235, _toDisplayString(_ctx.$t('transactions.imoneyFees')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.imoneyFees,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_236)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.operatorFees))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_237, [
                              _createElementVNode("label", _hoisted_238, _toDisplayString(_ctx.$t('transactions.operatorFees')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.operatorFees,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_239)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.user?.email))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_240, [
                              _createElementVNode("label", _hoisted_241, _toDisplayString(_ctx.$t('transactions.initiatedByUser')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.user?.email,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_242)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.business?.name))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                              _createElementVNode("label", _hoisted_244, _toDisplayString(_ctx.$t('transactions.businessLabel')), 1),
                              _createElementVNode("input", {
                                value: transaction.value.business?.name,
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_245)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.clientReference))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                              _createElementVNode("label", _hoisted_247, _toDisplayString(_ctx.$t('transactions.clientReference')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((transaction.value.clientReference) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.clientReference]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.clientId))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_248, [
                              _createElementVNode("label", _hoisted_249, _toDisplayString(_ctx.$t('transactions.clientId')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((transaction.value.clientId) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.clientId]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.handlingDate))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_250, [
                              _createElementVNode("label", _hoisted_251, _toDisplayString(_ctx.$t('transactions.handlingDate')), 1),
                              _createElementVNode("input", {
                                value: formatDateTimeFr(transaction.value.handlingDate),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_252)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.processingDate))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_253, [
                              _createElementVNode("label", _hoisted_254, _toDisplayString(_ctx.$t('transactions.processingDate')), 1),
                              _createElementVNode("input", {
                                value: formatDateTimeFr(transaction.value.processingDate),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_255)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.finalStateDate))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_256, [
                              _createElementVNode("label", _hoisted_257, _toDisplayString(_ctx.$t('transactions.finalStateDate')), 1),
                              _createElementVNode("input", {
                                value: formatDateTimeFr(transaction.value.finalStateDate),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_258)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.checkingDate))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_259, [
                              _createElementVNode("label", _hoisted_260, _toDisplayString(_ctx.$t('transactions.checkingDate')), 1),
                              _createElementVNode("input", {
                                value: formatDateTimeFr(transaction.value.checkingDate),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_261)
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.apiVersion))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                              _createElementVNode("label", _hoisted_263, _toDisplayString(_ctx.$t('transactions.apiVersion')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((transaction.value.apiVersion) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, transaction.value.apiVersion]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.errorMessage))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_264, [
                              _createElementVNode("label", _hoisted_265, _toDisplayString(_ctx.$t('transactions.errorMessage')), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((transaction.value.errorMessage) = $event)),
                                type: "text",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: "",
                                style: {"color":"red"}
                              }, null, 512), [
                                [_vModelText, transaction.value.errorMessage]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (hasValue(transaction.value.description))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_266, [
                              _createElementVNode("label", _hoisted_267, _toDisplayString(_ctx.$t('transactions.descriptionLabel')), 1),
                              _createElementVNode("textarea", {
                                value: transaction.value.description,
                                rows: "2",
                                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                                readonly: ""
                              }, null, 8, _hoisted_268)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 512)), [
                      [_vShow, activeDetailTab.value === 'advanced']
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_269, [
      _createElementVNode("div", _hoisted_270, [
        _createElementVNode("div", _hoisted_271, [
          _cache[132] || (_cache[132] = _createStaticVNode("<button type=\"button\" class=\"btn-close status-modal-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-2787f305></button><div class=\"edit-status-header\" data-v-2787f305><div class=\"edit-status-icon\" data-v-2787f305><i class=\"flaticon-pen\" data-v-2787f305></i></div><h5 class=\"mb-0 mt-10\" data-v-2787f305>Modifier le statut</h5></div>", 2)),
          _createElementVNode("div", _hoisted_272, [
            _createElementVNode("div", _hoisted_273, [
              _cache[123] || (_cache[123] = _createElementVNode("span", { class: "edit-status-code-label" }, "Code transaction", -1)),
              _createElementVNode("span", _hoisted_274, _toDisplayString(changeStatusCheckoutId.value || '—'), 1)
            ]),
            _createElementVNode("div", _hoisted_275, [
              _cache[125] || (_cache[125] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Statut ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((newStatusValue).value = $event)),
                class: "form-select fs-md-15 text-black shadow-none edit-status-select"
              }, [...(_cache[124] || (_cache[124] = [
                _createElementVNode("option", { value: "OPEN" }, "OPEN", -1),
                _createElementVNode("option", { value: "COMPLETED" }, "COMPLETED", -1)
              ]))], 512), [
                [_vModelSelect, newStatusValue.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_276, [
              _cache[127] || (_cache[127] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Statut de paiement ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((newPaymentStatusValue).value = $event)),
                class: "form-select fs-md-15 text-black shadow-none edit-status-select"
              }, [...(_cache[126] || (_cache[126] = [
                _createStaticVNode("<option value=\"SUCCEEDED\" data-v-2787f305>SUCCEEDED</option><option value=\"FAILED\" data-v-2787f305>FAILED</option><option value=\"PENDING\" data-v-2787f305>PENDING</option><option value=\"PROCESSING\" data-v-2787f305>PROCESSING</option><option value=\"INITIATED\" data-v-2787f305>INITIATED</option><option value=\"SCHEDULED\" data-v-2787f305>SCHEDULED</option>", 6)
              ]))], 512), [
                [_vModelSelect, newPaymentStatusValue.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_277, [
              _cache[128] || (_cache[128] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Description "),
                _createElementVNode("span", { class: "text-muted fw-normal" }, "(facultatif)")
              ], -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((newDescriptionValue).value = $event)),
                class: "form-control fs-md-15 text-black shadow-none edit-status-select",
                rows: "3",
                placeholder: "Ajouter une description…"
              }, null, 512), [
                [_vModelText, newDescriptionValue.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_278, [
              _cache[129] || (_cache[129] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" State "),
                _createElementVNode("span", { class: "text-muted fw-normal" }, "(facultatif)")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((newStateValue).value = $event)),
                type: "number",
                min: "0",
                max: "5",
                step: "1",
                class: "form-control fs-md-15 text-black shadow-none edit-status-select",
                placeholder: "0 à 5",
                onInput: onStateInput
              }, null, 544), [
                [_vModelText, newStateValue.value]
              ]),
              (stateError.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_279, _toDisplayString(stateError.value), 1))
                : _createCommentVNode("", true)
            ]),
            (changeStatusError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_280, _toDisplayString(changeStatusError.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_281, [
            _cache[131] || (_cache[131] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              "data-bs-dismiss": "modal"
            }, "Annuler", -1)),
            _createElementVNode("button", {
              type: "button",
              disabled: !btnLoadStatus.value,
              class: "btn edit-status-submit-btn",
              onClick: _cache[60] || (_cache[60] = ($event: any) => (submitChangeStatus()))
            }, [
              (!btnLoadStatus.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_283))
                : _createCommentVNode("", true),
              _cache[130] || (_cache[130] = _createElementVNode("span", { style: {"color":"#FFF"} }, "Valider", -1))
            ], 8, _hoisted_282)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_284, [
      _createElementVNode("div", _hoisted_285, [
        _createElementVNode("div", _hoisted_286, [
          _cache[137] || (_cache[137] = _createElementVNode("button", {
            type: "button",
            class: "btn-close status-modal-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1)),
          _createElementVNode("div", _hoisted_287, [
            (statusLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_288, [...(_cache[133] || (_cache[133] = [
                  _createElementVNode("span", {
                    class: "spinner-grow text-warning",
                    role: "status"
                  }, null, -1),
                  _createElementVNode("p", { class: "mt-15 mb-0 text-muted" }, "Vérification en cours...", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_289, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["status-icon-wrap", statusIconClass.value])
                  }, [
                    (statusDetails.value.paymentStatus==='SUCCEEDED')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_290))
                      : (statusDetails.value.paymentStatus==='FAILED')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_291))
                        : (_openBlock(), _createElementBlock("span", _hoisted_292, "⏳"))
                  ], 2),
                  _createElementVNode("h5", _hoisted_293, _toDisplayString(statusLabelText.value), 1),
                  _createElementVNode("p", _hoisted_294, _toDisplayString(statusDetails.value.checkoutId), 1),
                  _createElementVNode("div", _hoisted_295, [
                    _createTextVNode(_toDisplayString(Number(statusDetails.value.amount || 0).toLocaleString()) + " ", 1),
                    _cache[134] || (_cache[134] = _createElementVNode("span", null, "F CFA", -1))
                  ]),
                  _createElementVNode("div", _hoisted_296, [
                    _createElementVNode("div", _hoisted_297, [
                      _cache[135] || (_cache[135] = _createElementVNode("span", { class: "status-label" }, "Statut", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["status-pill", techStatusClass.value])
                      }, _toDisplayString(statusDetails.value.status || '—'), 3)
                    ]),
                    _createElementVNode("div", _hoisted_298, [
                      _cache[136] || (_cache[136] = _createElementVNode("span", { class: "status-label" }, "Statut paiement", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["status-pill", paymentStatusClass.value])
                      }, _toDisplayString(translatedPaymentStatus.value), 3)
                    ])
                  ])
                ]))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_299, [
      _createElementVNode("div", _hoisted_300, [
        _createElementVNode("div", _hoisted_301, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(generateLink, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_302, [
              _createElementVNode("h1", _hoisted_303, _toDisplayString(_ctx.$t('transactions.paymentLink')), 1),
              _cache[138] || (_cache[138] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_304, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_305, [
                    _createElementVNode("h6", _hoisted_306, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_307, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_308, [
                _createElementVNode("div", _hoisted_309, [
                  (_unref(result)!==1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_310))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_311, [
                    _createElementVNode("label", _hoisted_312, _toDisplayString(_ctx.$t('transactions.amount')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                        placeholder: "ex: 2000",
                        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (_isRef(amount) ? (amount).value = $event : amount = $event)),
                        id: "amount",
                        onBlur: _cache[62] || (_cache[62] = ($event: any) => (_unref(validate_phone_number)($event.target.value,$event.target,12))),
                        onKeyup: _cache[63] || (_cache[63] = ($event: any) => (_unref(validate_phone_number)($event.target.value,$event.target,12)))
                      }, null, 544), [
                        [_vModelText, _unref(amount)]
                      ])
                    ])
                  ]),
                  (_unref(result)==1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_313, [
                        _createElementVNode("label", _hoisted_314, _toDisplayString(_ctx.$t('transactions.link')), 1),
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                            "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (_isRef(link) ? (link).value = $event : link = $event)),
                            id: "link",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, _unref(link)]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(result)==1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_315, [
                        _createElementVNode("label", _hoisted_316, _toDisplayString(_ctx.$t('transactions.link')), 1),
                        _createElementVNode("div", _hoisted_317, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "text-decoration-none",
                            onClick: _withModifiers(copyToCliboard, ["prevent"])
                          }, [...(_cache[139] || (_cache[139] = [
                            _createElementVNode("i", {
                              class: "flaticon-draft fs-6",
                              style: {"color":"#000"}
                            }, null, -1)
                          ]))]),
                          _createElementVNode("a", {
                            href: "#",
                            class: "text-decoration-none",
                            onClick: _withModifiers(showQrCodeModal, ["prevent"]),
                            title: _ctx.$t('transactions.showQRCode')
                          }, [...(_cache[140] || (_cache[140] = [
                            _createElementVNode("i", {
                              class: "ph ph-qr-code fs-5",
                              style: {"color":"#000"}
                            }, null, -1)
                          ]))], 8, _hoisted_318)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_319, [
              _createElementVNode("button", {
                class: "default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[65] || (_cache[65] = ($event: any) => (reset()))
              }, [
                _cache[141] || (_cache[141] = _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('transactions.refresh')), 1)
              ]),
              (_unref(current_permissions)('create_public_token'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_320, [
                    (!btnLoad.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_321))
                      : _createCommentVNode("", true),
                    _cache[142] || (_cache[142] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('transactions.generatePaymentLink')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_322, [
      _createElementVNode("div", _hoisted_323, [
        _createElementVNode("div", _hoisted_324, [
          _createElementVNode("div", _hoisted_325, [
            _createElementVNode("h1", _hoisted_326, _toDisplayString(_ctx.$t('transactions.paymentQRCode')), 1),
            _cache[143] || (_cache[143] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_327, [
            (_unref(qrCodeDataUrl))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _unref(qrCodeDataUrl),
                  alt: "QR Code de paiement",
                  class: "qr-code-image mb-15"
                }, null, 8, _hoisted_328))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_329, _toDisplayString(_ctx.$t('transactions.scanToPay')), 1)
          ]),
          _createElementVNode("div", _hoisted_330, [
            _createElementVNode("button", _hoisted_331, _toDisplayString(_ctx.$t('transactions.close')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn text-white",
              style: {"background-color":"#EB9355"},
              onClick: downloadQrCode,
              disabled: !_unref(qrCodeDataUrl)
            }, _toDisplayString(_ctx.$t('transactions.download')), 9, _hoisted_332)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_333, [
      _createElementVNode("div", _hoisted_334, [
        _createElementVNode("div", _hoisted_335, [
          _createElementVNode("div", _hoisted_336, [
            _createElementVNode("div", _hoisted_337, [
              _createElementVNode("h2", _hoisted_338, [
                _cache[144] || (_cache[144] = _createElementVNode("span", null, [
                  _createElementVNode("img", {
                    src: _imports_3,
                    alt: "logo-icon",
                    style: {"max-width":"10%"}
                  }),
                  _createElementVNode("span", { class: "logo_text" }, "IZYPAY")
                ], -1)),
                _createElementVNode("span", _hoisted_339, _toDisplayString(_ctx.$t('transactions.transactionReceipt')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_340, [
              _cache[154] || (_cache[154] = _createStaticVNode("<div id=\"arrow-top-section\" data-v-2787f305><span id=\"arrow-top-left\" class=\"section_content\" data-v-2787f305><img src=\"" + _imports_4 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-2787f305></span><span id=\"arrow-top-right\" class=\"section_content\" data-v-2787f305><img src=\"" + _imports_5 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-2787f305></span></div>", 1)),
              _createElementVNode("div", _hoisted_341, [
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_342, _toDisplayString(_ctx.$t('transactions.operator')), 1),
                  _cache[145] || (_cache[145] = _createTextVNode(" : ", -1)),
                  _createElementVNode("span", _hoisted_343, _toDisplayString(operator.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_344, _toDisplayString(_ctx.$t('transactions.phone')), 1),
                  _cache[146] || (_cache[146] = _createTextVNode(" : ", -1)),
                  _createElementVNode("span", _hoisted_345, _toDisplayString(transaction.value.contact), 1)
                ]),
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_346, _toDisplayString(_ctx.$t('transactions.date')), 1),
                  _cache[147] || (_cache[147] = _createTextVNode(" : ", -1)),
                  _createElementVNode("span", _hoisted_347, _toDisplayString(formatDateFr(new Date(transaction.value.transactionDate))), 1)
                ]),
                _createElementVNode("p", _hoisted_348, [
                  _createElementVNode("span", _hoisted_349, _toDisplayString(_ctx.$t('transactions.transactionCode')), 1),
                  _createElementVNode("span", _hoisted_350, _toDisplayString(transaction.value.checkoutId), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_351, [
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_352, _toDisplayString(_ctx.$t('transactions.amountLabel')), 1),
                  _createElementVNode("span", _hoisted_353, _toDisplayString(_unref(amount)) + " F", 1)
                ]),
                (transaction.value.paymentStatus==='FAILED')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_354, [
                      _createElementVNode("span", _hoisted_355, _toDisplayString(_ctx.$t('transactions.statusLabel')), 1),
                      _createElementVNode("span", _hoisted_356, [
                        _createTextVNode(_toDisplayString(_ctx.$t('transactions.failed')) + " ", 1),
                        _cache[148] || (_cache[148] = _createElementVNode("img", {
                          src: _imports_6,
                          alt: "logo-icon",
                          style: {"max-width":"25%"}
                        }, null, -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (transaction.value.paymentStatus==='SUCCEEDED')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_357, [
                      _createElementVNode("span", _hoisted_358, _toDisplayString(_ctx.$t('transactions.statusLabel')), 1),
                      _createElementVNode("span", _hoisted_359, [
                        _createTextVNode(_toDisplayString(_ctx.$t('transactions.success')) + " ", 1),
                        _cache[149] || (_cache[149] = _createElementVNode("img", {
                          src: _imports_6,
                          alt: "logo-icon",
                          style: {"max-width":"25%"}
                        }, null, -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (transaction.value.paymentStatus==='PROCESSING')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_360, [
                      _createElementVNode("span", _hoisted_361, _toDisplayString(_ctx.$t('transactions.statusLabel')), 1),
                      _createElementVNode("span", _hoisted_362, [
                        _createTextVNode(_toDisplayString(_ctx.$t('transactions.processing')) + " ", 1),
                        _cache[150] || (_cache[150] = _createElementVNode("img", {
                          src: _imports_6,
                          alt: "logo-icon",
                          style: {"max-width":"25%"}
                        }, null, -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (transaction.value.paymentStatus==='PENDING')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_363, [
                      _createElementVNode("span", _hoisted_364, _toDisplayString(_ctx.$t('transactions.statusLabel')), 1),
                      _createElementVNode("span", _hoisted_365, [
                        _createTextVNode(_toDisplayString(_ctx.$t('transactions.pending')) + " ", 1),
                        _cache[151] || (_cache[151] = _createElementVNode("img", {
                          src: _imports_6,
                          alt: "logo-icon",
                          style: {"max-width":"25%"}
                        }, null, -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_366, [
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_367, _toDisplayString(_ctx.$t('transactions.thankYou')), 1),
                  _cache[152] || (_cache[152] = _createTextVNode("  ", -1)),
                  _cache[153] || (_cache[153] = _createElementVNode("span", { class: "section_content" }, [
                    _createElementVNode("img", {
                      src: _imports_7,
                      alt: "logo-icon",
                      style: {"max-width":"25%"}
                    })
                  ], -1))
                ])
              ]),
              _cache[155] || (_cache[155] = _createStaticVNode("<div id=\"arrow-bottom-section\" data-v-2787f305><span id=\"arrow-bottom-left\" class=\"section_content\" data-v-2787f305><img src=\"" + _imports_8 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-2787f305></span><span id=\"arrow-bottom-right\" class=\"section_content\" data-v-2787f305><img src=\"" + _imports_9 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-2787f305></span></div>", 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_368, [
            _createElementVNode("button", {
              class: "btn text-white",
              style: {"background-color":"#EB9355"},
              onClick: _cache[66] || (_cache[66] = ($event: any) => (download_receipt()))
            }, [
              (!btnLoad.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_369))
                : _createCommentVNode("", true),
              _cache[156] || (_cache[156] = _createElementVNode("i", {
                class: "flaticon-file-1 position-relative ms-5 fs-12",
                style: {"color":"#FFF"}
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('transactions.download')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      ref_key: "PDFReceipt",
      ref: PDFReceipt,
      id: "receipt",
      class: "form-group mb-15 mb-sm-20 mb-md-25 PDFReceipt d-none"
    }, [
      _createElementVNode("div", _hoisted_370, [
        _createElementVNode("h2", _hoisted_371, [
          _cache[157] || (_cache[157] = _createElementVNode("span", null, [
            _createElementVNode("img", {
              src: _imports_3,
              alt: "logo-icon",
              style: {"max-width":"10%"}
            }),
            _createElementVNode("span", { class: "logo_text" }, "IZYPAY")
          ], -1)),
          _createElementVNode("span", _hoisted_372, _toDisplayString(_ctx.$t('transactions.transactionReceipt')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_373, [
        _cache[168] || (_cache[168] = _createStaticVNode("<div id=\"arrow-top-section\" data-v-2787f305><span id=\"arrow-top-left\" class=\"section_content\" data-v-2787f305><img src=\"" + _imports_4 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-2787f305></span><span id=\"arrow-top-right\" class=\"section_content\" data-v-2787f305><img src=\"" + _imports_5 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-2787f305></span></div>", 1)),
        _createElementVNode("div", _hoisted_374, [
          (transaction.value.clientId != '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_375, [
                _createElementVNode("span", _hoisted_376, _toDisplayString(_ctx.$t('transactions.beneficiary')), 1),
                _cache[158] || (_cache[158] = _createTextVNode(" : ", -1)),
                _createElementVNode("span", _hoisted_377, _toDisplayString(transaction.value.clientId), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_378, _toDisplayString(_ctx.$t('transactions.operator')), 1),
            _cache[159] || (_cache[159] = _createTextVNode(" : ", -1)),
            _createElementVNode("span", _hoisted_379, _toDisplayString(operator.value), 1)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_380, _toDisplayString(_ctx.$t('transactions.phone')), 1),
            _cache[160] || (_cache[160] = _createTextVNode(" : ", -1)),
            _createElementVNode("span", _hoisted_381, _toDisplayString(transaction.value.contact), 1)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_382, _toDisplayString(_ctx.$t('transactions.date')), 1),
            _cache[161] || (_cache[161] = _createTextVNode(" : ", -1)),
            _createElementVNode("span", _hoisted_383, _toDisplayString(formatDateFr(new Date(transaction.value.transactionDate))), 1)
          ]),
          _createElementVNode("p", _hoisted_384, [
            _createElementVNode("span", _hoisted_385, _toDisplayString(_ctx.$t('transactions.transactionCode')), 1),
            _createElementVNode("span", _hoisted_386, _toDisplayString(transaction.value.checkoutId), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_387, [
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_388, _toDisplayString(_ctx.$t('transactions.amountLabel')), 1),
            _createElementVNode("span", _hoisted_389, _toDisplayString(transaction.value.amount) + " F", 1)
          ]),
          (transaction.value.paymentStatus === 'FAILED')
            ? (_openBlock(), _createElementBlock("p", _hoisted_390, [
                _createElementVNode("span", _hoisted_391, _toDisplayString(_ctx.$t('transactions.statusLabel')), 1),
                _createElementVNode("span", _hoisted_392, [
                  _createTextVNode(_toDisplayString(_ctx.$t('transactions.failed')) + " ", 1),
                  _cache[162] || (_cache[162] = _createElementVNode("img", {
                    src: _imports_6,
                    alt: "logo-icon",
                    style: {"max-width":"25%"}
                  }, null, -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (transaction.value.paymentStatus === 'SUCCEEDED')
            ? (_openBlock(), _createElementBlock("p", _hoisted_393, [
                _createElementVNode("span", _hoisted_394, _toDisplayString(_ctx.$t('transactions.statusLabel')), 1),
                _createElementVNode("span", _hoisted_395, [
                  _createTextVNode(_toDisplayString(_ctx.$t('transactions.success')) + " ", 1),
                  _cache[163] || (_cache[163] = _createElementVNode("img", {
                    src: _imports_6,
                    alt: "logo-icon",
                    style: {"max-width":"25%"}
                  }, null, -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (transaction.value.paymentStatus === 'PROCESSING')
            ? (_openBlock(), _createElementBlock("p", _hoisted_396, [
                _createElementVNode("span", _hoisted_397, _toDisplayString(_ctx.$t('transactions.statusLabel')), 1),
                _createElementVNode("span", _hoisted_398, [
                  _createTextVNode(_toDisplayString(_ctx.$t('transactions.processing')) + " ", 1),
                  _cache[164] || (_cache[164] = _createElementVNode("img", {
                    src: _imports_6,
                    alt: "logo-icon",
                    style: {"max-width":"25%"}
                  }, null, -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (transaction.value.paymentStatus === 'PENDING')
            ? (_openBlock(), _createElementBlock("p", _hoisted_399, [
                _createElementVNode("span", _hoisted_400, _toDisplayString(_ctx.$t('transactions.statusLabel')), 1),
                _createElementVNode("span", _hoisted_401, [
                  _createTextVNode(_toDisplayString(_ctx.$t('transactions.pending')) + " ", 1),
                  _cache[165] || (_cache[165] = _createElementVNode("img", {
                    src: _imports_6,
                    alt: "logo-icon",
                    style: {"max-width":"25%"}
                  }, null, -1))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_402, [
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_403, _toDisplayString(_ctx.$t('transactions.thankYou')), 1),
            _cache[166] || (_cache[166] = _createTextVNode("  ", -1)),
            _cache[167] || (_cache[167] = _createElementVNode("span", { class: "section_content" }, [
              _createElementVNode("img", {
                src: _imports_7,
                alt: "logo-icon",
                style: {"max-width":"25%"}
              })
            ], -1))
          ])
        ]),
        _cache[169] || (_cache[169] = _createStaticVNode("<div id=\"arrow-bottom-section\" data-v-2787f305><span id=\"arrow-bottom-left\" class=\"section_content\" data-v-2787f305><img src=\"" + _imports_8 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-2787f305></span><span id=\"arrow-bottom-right\" class=\"section_content\" data-v-2787f305><img src=\"" + _imports_9 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-2787f305></span></div>", 1))
      ])
    ], 512),
    _cache[170] || (_cache[170] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})